import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelText as _vModelText, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  class: "flex items-center gap-4"
};
const _hoisted_3 = {
  key: 0,
  class: "w-6 h-6 text-purple-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_4 = {
  key: 1,
  class: "w-6 h-6 text-green-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_5 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_6 = {
  class: "flex items-center gap-2 mt-1"
};
const _hoisted_7 = {
  key: 0,
  class: "px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded text-xs"
};
const _hoisted_8 = {
  class: "text-xs text-slate-500"
};
const _hoisted_9 = {
  class: "flex h-[calc(90vh-120px)]"
};
const _hoisted_10 = {
  class: "w-56 border-r border-slate-200 bg-slate-50 py-4"
};
const _hoisted_11 = {
  class: "space-y-1"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "space-y-6"
};
const _hoisted_14 = {
  class: "flex items-center justify-between"
};
const _hoisted_15 = {
  class: "grid grid-cols-2 lg:grid-cols-4 gap-4"
};
const _hoisted_16 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_17 = {
  class: "font-medium text-slate-900"
};
const _hoisted_18 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_19 = {
  class: "font-medium text-slate-900"
};
const _hoisted_20 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_21 = {
  class: "font-medium text-slate-900"
};
const _hoisted_22 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_23 = {
  class: "font-medium text-slate-900"
};
const _hoisted_24 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_25 = {
  class: "font-medium text-slate-900"
};
const _hoisted_26 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_27 = {
  class: "font-medium text-slate-900"
};
const _hoisted_28 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_29 = {
  class: "font-medium text-slate-900"
};
const _hoisted_30 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_31 = {
  class: "flex flex-col items-start gap-1.5"
};
const _hoisted_32 = {
  class: "font-medium text-slate-900"
};
const _hoisted_33 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_34 = {
  class: "font-medium text-slate-900"
};
const _hoisted_35 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_36 = {
  class: "font-medium text-primary-600"
};
const _hoisted_37 = {
  class: "col-span-2 bg-slate-50 rounded-lg p-4"
};
const _hoisted_38 = {
  class: "font-medium text-slate-900"
};
const _hoisted_39 = {
  class: "col-span-2 bg-slate-50 rounded-lg p-4"
};
const _hoisted_40 = {
  class: "font-medium text-slate-900"
};
const _hoisted_41 = {
  class: "col-span-2 bg-slate-50 rounded-lg p-4"
};
const _hoisted_42 = {
  class: "flex flex-wrap gap-1 mt-1"
};
const _hoisted_43 = {
  key: 0,
  class: "text-slate-400"
};
const _hoisted_44 = {
  class: "col-span-2 bg-slate-50 rounded-lg p-4"
};
const _hoisted_45 = {
  class: "font-medium text-slate-900"
};
const _hoisted_46 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_47 = {
  class: "flex justify-between items-center"
};
const _hoisted_48 = {
  key: 0,
  class: "border border-dashed border-slate-200 rounded-lg py-10 text-center text-sm text-slate-500"
};
const _hoisted_49 = {
  key: 1,
  class: "grid gap-4"
};
const _hoisted_50 = {
  class: "flex items-start justify-between p-4 bg-slate-50"
};
const _hoisted_51 = {
  class: "flex items-start gap-3"
};
const _hoisted_52 = {
  class: "font-medium text-slate-900"
};
const _hoisted_53 = {
  class: "text-sm text-slate-500 mt-1"
};
const _hoisted_54 = {
  class: "flex items-center gap-2"
};
const _hoisted_55 = ["onClick"];
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  class: "p-4"
};
const _hoisted_58 = {
  class: "grid grid-cols-2 lg:grid-cols-4 gap-4"
};
const _hoisted_59 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_60 = {
  class: "text-sm text-slate-700"
};
const _hoisted_61 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_62 = {
  class: "text-sm text-slate-700"
};
const _hoisted_63 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_64 = {
  class: "text-sm text-slate-700"
};
const _hoisted_65 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_66 = {
  class: "text-sm text-slate-700"
};
const _hoisted_67 = {
  class: "col-span-2 bg-slate-50 rounded-lg p-3"
};
const _hoisted_68 = {
  class: "text-sm text-slate-700"
};
const _hoisted_69 = {
  class: "col-span-4 bg-slate-50 rounded-lg p-3"
};
const _hoisted_70 = {
  class: "text-sm text-slate-700"
};
const _hoisted_71 = {
  key: 2,
  class: "space-y-4"
};
const _hoisted_72 = {
  class: "flex justify-between items-center"
};
const _hoisted_73 = {
  key: 3,
  class: "space-y-4"
};
const _hoisted_74 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_75 = {
  key: 1,
  class: "border border-dashed border-slate-200 rounded-lg py-10 text-center text-sm text-slate-500"
};
const _hoisted_76 = {
  key: 2,
  class: "overflow-x-auto"
};
const _hoisted_77 = {
  class: "w-full"
};
const _hoisted_78 = {
  class: "divide-y divide-slate-200"
};
const _hoisted_79 = {
  class: "px-4 py-3"
};
const _hoisted_80 = {
  class: "flex items-center gap-3"
};
const _hoisted_81 = {
  class: "font-medium text-slate-900"
};
const _hoisted_82 = {
  class: "text-xs text-slate-500"
};
const _hoisted_83 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_84 = {
  key: 0,
  class: "px-2 py-1 bg-slate-100 text-slate-700 rounded text-xs"
};
const _hoisted_85 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_86 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_87 = {
  class: "flex items-center gap-2"
};
const _hoisted_88 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_89 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_90 = {
  class: "px-4 py-3 text-sm text-slate-900 text-right font-medium"
};
const _hoisted_91 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_92 = {
  class: "px-4 py-3 text-sm text-slate-600 text-center"
};
const _hoisted_93 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_94 = {
  class: "flex justify-center gap-1"
};
const _hoisted_95 = ["onClick"];
const _hoisted_96 = {
  key: 3,
  class: "flex items-center justify-between text-sm text-slate-500"
};
const _hoisted_97 = {
  class: "font-medium"
};
const _hoisted_98 = {
  class: "font-medium"
};
const _hoisted_99 = {
  class: "font-medium"
};
const _hoisted_100 = {
  key: 4,
  class: "space-y-6"
};
const _hoisted_101 = {
  class: "flex justify-between items-center"
};
const _hoisted_102 = {
  key: 0,
  class: "border border-dashed border-slate-200 rounded-lg py-10 text-center text-sm text-slate-500"
};
const _hoisted_103 = {
  key: 1,
  class: "border border-dashed border-slate-200 rounded-lg py-10 text-center text-sm text-slate-500"
};
const _hoisted_104 = {
  key: 2,
  class: "space-y-6"
};
const _hoisted_105 = {
  class: "text-sm font-medium text-slate-700 flex items-center gap-2"
};
const _hoisted_106 = {
  class: "grid grid-cols-2 lg:grid-cols-3 gap-4"
};
const _hoisted_107 = ["onClick"];
const _hoisted_108 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_109 = {
  class: "flex-1 min-w-0"
};
const _hoisted_110 = {
  class: "font-medium text-slate-900 truncate flex items-center gap-2"
};
const _hoisted_111 = {
  key: 0,
  class: "text-xs px-1.5 py-0.5 rounded bg-rose-50 text-rose-600 border border-rose-200"
};
const _hoisted_112 = {
  class: "text-xs text-slate-500 mt-1 truncate"
};
const _hoisted_113 = {
  key: 0
};
const _hoisted_114 = {
  key: 1
};
const _hoisted_115 = {
  class: "mt-3 text-xs text-slate-500 space-y-1"
};
const _hoisted_116 = {
  key: 0
};
const _hoisted_117 = {
  class: "mt-3"
};
const _hoisted_118 = ["onClick"];
const _hoisted_119 = {
  key: 5,
  class: "space-y-4"
};
const _hoisted_120 = {
  class: "flex justify-between items-center"
};
const _hoisted_121 = {
  key: 0,
  class: "border border-dashed border-slate-200 rounded-lg py-10 text-center text-sm text-slate-500"
};
const _hoisted_122 = {
  key: 1,
  class: "relative"
};
const _hoisted_123 = {
  class: "space-y-4"
};
const _hoisted_124 = {
  class: "border border-slate-200 rounded-lg p-4 hover:shadow-md transition-shadow"
};
const _hoisted_125 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_126 = {
  class: "flex items-center gap-2"
};
const _hoisted_127 = {
  class: "text-xs text-slate-500"
};
const _hoisted_128 = {
  class: "flex items-center gap-1"
};
const _hoisted_129 = {
  class: "text-xs text-slate-500"
};
const _hoisted_130 = ["onClick"];
const _hoisted_131 = ["onClick"];
const _hoisted_132 = {
  class: "text-sm text-slate-700"
};
const _hoisted_133 = {
  class: "flex items-center gap-4 mt-3 text-xs text-slate-500"
};
const _hoisted_134 = {
  key: 0
};
const _hoisted_135 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_136 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_137 = {
  class: "text-xs text-slate-500"
};
const _hoisted_138 = {
  class: "p-6 space-y-6 overflow-y-auto max-h-[calc(90vh-160px)]"
};
const _hoisted_139 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_140 = ["label"];
const _hoisted_141 = ["value"];
const _hoisted_142 = {
  key: 0
};
const _hoisted_143 = {
  class: "flex items-center"
};
const _hoisted_144 = {
  class: "form-switch"
};
const _hoisted_145 = {
  class: "ml-2 text-sm text-slate-500"
};
const _hoisted_146 = {
  key: 0
};
const _hoisted_147 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_148 = {
  class: "block text-sm font-medium text-slate-700 mb-2"
};
const _hoisted_149 = {
  key: 0,
  class: "text-red-500"
};
const _hoisted_150 = ["onUpdate:modelValue"];
const _hoisted_151 = ["value"];
const _hoisted_152 = ["onUpdate:modelValue"];
const _hoisted_153 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_154 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_155 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_156 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_157 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_158 = {
  key: 1
};
const _hoisted_159 = {
  class: "space-y-4"
};
const _hoisted_160 = {
  class: "flex items-center justify-between"
};
const _hoisted_161 = {
  class: "font-medium text-slate-900"
};
const _hoisted_162 = {
  key: 0,
  class: "text-xs px-1.5 py-0.5 rounded bg-rose-50 text-rose-600 border border-rose-200"
};
const _hoisted_163 = {
  class: "mt-3 space-y-2"
};
const _hoisted_164 = {
  class: "material-file-main"
};
const _hoisted_165 = ["title"];
const _hoisted_166 = {
  class: "material-file-meta"
};
const _hoisted_167 = {
  class: "material-file-actions"
};
const _hoisted_168 = ["onClick"];
const _hoisted_169 = ["onClick"];
const _hoisted_170 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_171 = {
  class: "mt-4 grid grid-cols-1 md:grid-cols-3 gap-3"
};
const _hoisted_172 = {
  class: "material-file-picker"
};
const _hoisted_173 = ["accept", "onChange"];
const _hoisted_174 = ["onClick"];
const _hoisted_175 = ["title"];
const _hoisted_176 = ["onUpdate:modelValue"];
const _hoisted_177 = ["onClick", "disabled"];
const _hoisted_178 = {
  key: 0,
  class: "text-xs text-amber-600 mt-2"
};
const _hoisted_179 = {
  class: "px-6 py-4 border-t border-slate-200 flex flex-col md:flex-row md:items-center md:justify-between gap-3"
};
const _hoisted_180 = {
  class: "text-xs text-slate-500"
};
const _hoisted_181 = {
  key: 0
};
const _hoisted_182 = {
  key: 1
};
const _hoisted_183 = {
  class: "flex items-center justify-end gap-3"
};
const _hoisted_184 = ["disabled"];
const _hoisted_185 = {
  class: "p-6 text-sm text-slate-600"
};
const _hoisted_186 = {
  class: "p-6 text-sm text-slate-600"
};
const _hoisted_187 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_188 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_189 = {
  class: "p-6 space-y-4"
};
const _hoisted_190 = {
  class: "grid grid-cols-4 gap-2"
};
const _hoisted_191 = ["onClick"];
const _hoisted_192 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_193 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_194 = ["disabled"];
const _hoisted_195 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_196 = {
  class: "p-6"
};
const _hoisted_197 = {
  class: "mb-6 p-4 bg-slate-50 rounded-lg space-y-2"
};
const _hoisted_198 = {
  class: "flex items-center gap-3"
};
const _hoisted_199 = {
  class: "text-sm text-slate-900"
};
const _hoisted_200 = {
  key: 0,
  class: "flex items-center gap-3"
};
const _hoisted_201 = {
  class: "text-sm text-slate-900"
};
const _hoisted_202 = {
  key: 1,
  class: "flex items-center gap-3"
};
const _hoisted_203 = {
  class: "flex items-center gap-2"
};
const _hoisted_204 = {
  class: "w-6 h-6 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center text-white text-xs font-medium"
};
const _hoisted_205 = {
  class: "text-sm text-slate-900"
};
const _hoisted_206 = {
  key: 2,
  class: "flex items-center gap-3"
};
const _hoisted_207 = {
  class: "text-sm text-slate-900"
};
const _hoisted_208 = {
  key: 3,
  class: "flex items-center gap-3"
};
const _hoisted_209 = {
  class: "text-sm text-slate-900"
};
const _hoisted_210 = {
  class: "flex items-center gap-3 w-full"
};
const _hoisted_211 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_212 = ["disabled"];
const _hoisted_213 = {
  class: "p-6"
};
const _hoisted_214 = {
  class: "text-lg font-medium text-slate-900"
};
const _hoisted_215 = {
  class: "text-slate-600"
};
const _hoisted_216 = {
  class: "text-amber-600 font-medium"
};
const _hoisted_217 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_218 = ["disabled"];
import { ref, reactive, computed, watch, nextTick } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { getPlanPage } from '@/api/plan';
import { getOrderPage, getOrderDetail, updateOrderStatus } from '@/api/order';
import { receiveBilling } from '@/api/billing';
import { getTraceList } from '@/api/trace';
import { updateTask } from '@/api/task';
import { getCompanyPage, getCustomer, getCustomerFollowPage, createCustomerFollow, updateCustomerFollow, deleteCustomerFollow, getCustomerMaterialTypes, getCustomerMaterials, getCustomerMaterialDetail, getCustomerMaterialDetailById, submitCustomerMaterial, uploadCustomerMaterialFile, deleteCustomerMaterial, deleteCustomerMaterialFile } from '@/api/customer';
import { uploadFile } from '@/api/file';
import AppModal from '@/components/AppModal.vue';
import PlanDetailModal from '@/components/PlanDetailModal.vue';
import OrderDetailModal from '@/components/OrderDetailModal.vue';
import OrderFormModal from '@/components/OrderFormModal.vue';
import ProposalFormModal from '@/components/ProposalFormModal.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import OrderListTable from '@/components/OrderListTable.vue';
import ProposalListTable from '@/components/ProposalListTable.vue';
import FileAttachment from '@/components/FileAttachment.vue';
import { normalizeCustomerFollowTime } from '@/utils/customerFollow';
import { normalizeCustomerMaterialFile, withBlobPreview } from '@/utils/filePreview';
import { PREVIEWABLE_ATTACHMENT_ACCEPT, PREVIEWABLE_ATTACHMENT_ACCEPT_LABEL, isPreviewableAttachmentFile } from '@/utils/fileAccept';

// Icon components

export default {
  __name: 'CustomerDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: null
    },
    visibleTabs: {
      type: Array,
      default: () => ['basic', 'enterprises', 'proposals', 'orders', 'documents', 'followup']
    },
    initialTab: {
      type: String,
      default: 'basic'
    },
    highlightFollowId: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['update:modelValue', 'edit-customer', 'open-add-enterprise', 'open-edit-enterprise', 'delete-company', 'refresh', 'refresh-enterprises'],
  setup(__props, {
    emit: __emit
  }) {
    const IconUser = {
      template: `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>`
    };
    const IconBuilding = {
      template: `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>`
    };
    const IconDocument = {
      template: `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>`
    };
    const IconShopping = {
      template: `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg>`
    };
    const IconFile = {
      template: `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"/></svg>`
    };
    const IconChat = {
      template: `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/></svg>`
    };
    const props = __props;
    const emit = __emit;

    // Tab state
    const activeDetailTab = ref('basic');

    // Refs
    const detailContentRef = ref(null);

    // Modal state
    const showMaterialModal = ref(false);
    const showDeleteMaterialModal = ref(false);
    const showDeleteMaterialFileModal = ref(false);
    const showFollowupModal = ref(false);
    const showDeleteFollowupModal = ref(false);
    const showPlanDetailModal = ref(false);
    const showOrderDetailModal = ref(false);
    const showOrderEditModal = ref(false);
    const showTaskEditModal = ref(false);
    const showBillingReceiveModal = ref(false);
    const showProposalFormModal = ref(false);
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);
    const selectedApprovalType = ref('proposal');
    const editOrderData = ref(null);
    const selectedTask = ref(null);
    const selectedBilling = ref(null);
    const taskFormRef = ref(null);
    const receiveFormRef = ref(null);
    const taskSubmitting = ref(false);
    const receiveSubmitting = ref(false);
    const isProposalEdit = ref(false);
    const proposalFormCurrentPlan = ref(null);
    const isFollowupFetching = ref(false);
    const isCompanyFetching = ref(false);
    const isFollowupSubmitting = ref(false);

    // Loading states
    const isMaterialTypesLoading = ref(false);
    const isMaterialListLoading = ref(false);
    const isMaterialSaving = ref(false);
    const isProposalLoading = ref(false);
    const isOrderLoading = ref(false);
    const isCustomerDetailLoading = ref(false);

    // Data refs
    const relatedEnterprises = ref([]);
    const customerProposals = ref([]);
    const customerOrders = ref([]);
    const followupRecords = ref([]);
    const customerDetail = ref(null);
    const planDetail = ref(null);
    const orderDetail = ref(null);
    const orderTraceList = ref([]);

    // Pagination
    const followupPagination = reactive({
      page: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    const companyPagination = reactive({
      page: 1,
      size: 20,
      total: 0,
      pages: 0
    });
    const proposalPagination = reactive({
      page: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    const orderPagination = reactive({
      page: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    const taskFormData = reactive({
      status: 0,
      progress: 0,
      remark: ''
    });
    const receiveFormData = reactive({
      paidAmount: 0,
      payChannel: ''
    });

    // Tab definitions
    const detailTabs = [{
      label: '基本信息',
      value: 'basic',
      icon: IconUser
    }, {
      label: '关联企业',
      value: 'enterprises',
      icon: IconBuilding
    }, {
      label: '客户方案',
      value: 'proposals',
      icon: IconDocument
    }, {
      label: '订单信息',
      value: 'orders',
      icon: IconShopping
    }, {
      label: '客户资料',
      value: 'documents',
      icon: IconFile
    }, {
      label: '跟进记录',
      value: 'followup',
      icon: IconChat
    }];
    const visibleTabsArr = computed(() => props.visibleTabs || ['basic', 'enterprises', 'proposals', 'orders', 'documents', 'followup']);
    const visibleDetailTabs = computed(() => detailTabs.filter(tab => visibleTabsArr.value.includes(tab.value)));
    const proposalFormEditData = computed(() => {
      if (isProposalEdit.value) {
        return proposalFormCurrentPlan.value;
      }
      return {
        customerId: customerDetail.value?.id,
        customerName: customerDetail.value?.name || ''
      };
    });
    const receiveRemainingAmount = computed(() => {
      if (!selectedBilling.value) return 0;
      return (selectedBilling.value.amount || 0) - (selectedBilling.value.paidAmount || 0);
    });

    // Material related
    const materialTypeCategories = ref([]);
    const customerMaterials = ref([]);
    const selectedMaterialDefinitionCode = ref('');
    const activeMaterialDefinition = ref(null);
    const materialDetail = ref(null);
    const materialSchema = ref(null);
    const materialFileConfig = ref({
      files: []
    });
    const materialModalMode = ref('create'); // 'create' | 'edit'
    const materialForm = reactive({
      definitionCode: '',
      name: '',
      expireDate: '',
      visibleToCustomer: false
    });
    const materialFormData = reactive({});
    const uploadFileStates = reactive({});
    const materialFileInputRefs = {};
    const materialToDelete = ref(null);
    const materialFileToDelete = ref(null);
    let materialDetailRequestSeq = 0;
    const receiveRules = {
      paidAmount: [{
        required: true,
        message: '请输入收款金额',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (!value || value <= 0) {
            callback(new Error('收款金额必须大于0'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      payChannel: [{
        required: true,
        message: '请选择支付渠道',
        trigger: 'change'
      }]
    };
    const taskRules = {
      status: [{
        required: true,
        message: '请选择任务状态',
        trigger: 'change'
      }],
      progress: [{
        required: true,
        message: '请输入任务进度',
        trigger: 'blur'
      }, {
        type: 'number',
        min: 0,
        max: 100,
        message: '进度必须在0-100之间',
        trigger: 'blur'
      }]
    };
    const payChannelOptions = [{
      label: '微信',
      value: 'WECHAT'
    }, {
      label: '支付宝',
      value: 'ALIPAY'
    }, {
      label: '银行转账',
      value: 'BANK_TRANSFER'
    }, {
      label: '现金',
      value: 'CASH'
    }, {
      label: '其他',
      value: 'OTHER'
    }];

    // Maps
    const followupTypeLabelMap = {
      0: '电话',
      1: '微信',
      2: '邮件',
      3: '上门',
      4: '其他'
    };
    const followupTypeValueMap = {
      '电话': 0,
      '微信': 1,
      '邮件': 2,
      '上门': 3,
      '其他': 4
    };
    const orderStatusMap = {
      0: {
        text: '待开始',
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: '服务中',
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: '已完成',
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: '已取消',
        class: 'bg-red-100 text-red-700'
      }
    };

    // Followup types
    const followupTypes = [{
      label: '电话',
      value: '电话'
    }, {
      label: '微信',
      value: '微信'
    }, {
      label: '邮件',
      value: '邮件'
    }, {
      label: '上门',
      value: '上门'
    }, {
      label: '其他',
      value: '其他'
    }];

    // Followup form
    const followupForm = reactive({
      id: null,
      type: '电话',
      content: '',
      duration: '',
      nextDate: '',
      followTime: ''
    });
    const followupToDelete = ref(null);

    // Helper functions
    const normalizeFollowupTypeLabel = label => {
      if (label === '拜访') return '上门';
      return label || '';
    };
    const parseFollowupDuration = remark => {
      const value = String(remark ?? '').trim();
      if (!value) return '';
      if (/^\d+$/.test(value)) return Number(value);
      const match = value.match(/\d+/);
      return match ? Number(match[0]) : '';
    };
    const formatFollowupTimeLabel = value => {
      if (!value) return '';
      return String(value).replace('T', ' ').replace('Z', '');
    };
    const mapFollowupFromApi = (data = {}) => {
      const label = normalizeFollowupTypeLabel(data.followTypeName || followupTypeLabelMap[data.followType]);
      return {
        id: data.id,
        type: label || '其他',
        date: formatFollowupTimeLabel(data.followTime),
        content: data.followContent || '',
        operator: data.createBy || '',
        nextDate: data.nextFollowTime ? String(data.nextFollowTime).split('T')[0] : '',
        duration: parseFollowupDuration(data.remark),
        followTimeRaw: data.followTime || ''
      };
    };
    const mapCompanyFromApi = (data = {}) => {
      return {
        id: data.id,
        name: data.companyName || '',
        relation: data.remark || '-',
        status: data.status,
        statusLabel: data.status === 1 ? '停用' : '正常',
        creditCode: data.socialCreditCode || '',
        legalPerson: data.legalPerson || '',
        registeredCapital: data.registeredCapital || '',
        establishedDate: data.establishmentDate || '',
        companyAddress: data.registeredAddress || '',
        businessScope: data.businessScope || '',
        licenseUrl: data.licenseUrl || '',
        licensePreviewUrl: data.licensePreviewUrl || data.licenseUrl || '',
        remark: data.remark || ''
      };
    };
    const mapFollowupToForm = (record = {}) => {
      Object.assign(followupForm, {
        id: record.id || null,
        type: record.type || '电话',
        content: record.content || '',
        duration: record.duration || '',
        nextDate: record.nextDate || '',
        followTime: record.followTimeRaw || ''
      });
    };

    // 生成东八区（UTC+8）的ISO时间格式
    const toEastAsiaISO = (date = new Date()) => {
      const offset = 8 * 60; // 东八区偏移分钟数
      const utcTime = date.getTime() + offset * 60 * 1000;
      const eastAsiaDate = new Date(utcTime);
      const isoString = eastAsiaDate.toISOString().slice(0, -1); // 移除末尾的 'Z'
      return isoString;
    };
    const formatDateTimeFromDateInput = value => {
      if (!value) return undefined;
      // 将日期字符串转换为东八区ISO格式（设置为当天00:00:00）
      const date = new Date(value + 'T00:00:00');
      return toEastAsiaISO(date);
    };
    const buildFollowupPayload = (options = {}) => {
      const {
        isUpdate = false
      } = options;
      const followType = followupTypeValueMap[followupForm.type];
      return {
        customerId: customerDetail.value?.id,
        followType: Number.isInteger(followType) ? followType : undefined,
        followContent: followupForm.content?.trim(),
        followTime: normalizeCustomerFollowTime(followupForm.followTime || (isUpdate ? undefined : toEastAsiaISO())),
        nextFollowTime: formatDateTimeFromDateInput(followupForm.nextDate),
        remark: followupForm.duration ? String(followupForm.duration).trim() : undefined
      };
    };

    // Format functions
    const formatDate = value => {
      if (!value) return '-';
      return String(value).slice(0, 10);
    };
    const formatDateTime = value => {
      if (!value) return '-';
      return String(value).replace('T', ' ').slice(0, 19);
    };
    const formatFileSize = size => {
      if (!size && size !== 0) return '-';
      const units = ['B', 'KB', 'MB', 'GB'];
      let value = size;
      let index = 0;
      while (value >= 1024 && index < units.length - 1) {
        value /= 1024;
        index += 1;
      }
      return `${value.toFixed(value >= 10 || index === 0 ? 0 : 1)}${units[index]}`;
    };

    // Class getters
    const getTypeClass = type => {
      return type === '企业' ? 'bg-purple-100 text-purple-700' : 'bg-green-100 text-green-700';
    };
    const getFollowupTypeClass = type => {
      const classes = {
        '电话': 'bg-blue-100 text-blue-700',
        '微信': 'bg-green-100 text-green-700',
        '邮件': 'bg-amber-100 text-amber-700',
        '上门': 'bg-purple-100 text-purple-700',
        '拜访': 'bg-purple-100 text-purple-700',
        '其他': 'bg-slate-100 text-slate-700'
      };
      return classes[type] || 'bg-slate-100 text-slate-700';
    };
    const getFollowupIconClass = type => {
      const classes = {
        '电话': 'border-blue-500 bg-blue-50',
        '微信': 'border-green-500 bg-green-50',
        '邮件': 'border-amber-500 bg-amber-50',
        '上门': 'border-purple-500 bg-purple-50',
        '拜访': 'border-purple-500 bg-purple-50',
        '其他': 'border-slate-500 bg-slate-50'
      };
      return classes[type] || 'border-slate-300';
    };

    // Material computed
    const materialDefinitionMap = computed(() => {
      const map = new Map();
      materialTypeCategories.value.forEach(category => {
        (category.materialDefinitions || []).forEach(definition => {
          map.set(definition.code, definition);
        });
      });
      return map;
    });

    // 解析标签（支持逗号分隔的字符串或数组）
    const parsedTags = computed(() => {
      const tags = customerDetail.value?.tags;
      if (!tags) return [];
      if (Array.isArray(tags)) return tags.filter(t => t && t.trim());
      if (typeof tags === 'string') {
        return tags.split(',').map(t => t.trim()).filter(t => t);
      }
      return [];
    });
    const hasCustomerPendingApproval = computed(() => {
      return customerDetail.value?.pendingApprovalInstanceId != null;
    });
    const materialInstanceMap = computed(() => {
      const map = new Map();
      customerMaterials.value.forEach(category => {
        (category.materials || []).forEach(material => {
          map.set(material.definitionCode, material);
        });
      });
      return map;
    });
    const materialCategoryDisplays = computed(() => {
      return customerMaterials.value.map(category => {
        const items = (category.materials || []).map(material => ({
          definition: materialDefinitionMap.value.get(material.definitionCode) || {
            code: material.definitionCode,
            name: material.definitionName,
            nameAlias: material.definitionName
          },
          material
        }));
        return {
          ...category,
          items
        };
      }).filter(category => category.items.length);
    });
    const materialFormFields = computed(() => {
      const schema = materialSchema.value;
      if (!schema || schema.type !== 'object' || !schema.properties) return [];
      const requiredSet = new Set(schema.required || []);
      return Object.entries(schema.properties).map(([key, config = {}]) => ({
        key,
        label: config.title || config.label || key,
        type: config.type || 'string',
        format: config.format || '',
        enum: Array.isArray(config.enumValues) ? config.enumValues : null,
        required: requiredSet.has(key),
        placeholder: config.placeholder || ''
      }));
    });
    const materialFileFields = computed(() => {
      return materialFileConfig.value?.files || [];
    });

    // Utility functions
    const parseJsonSafely = (value, fallback) => {
      if (value === null || value === undefined || value === '') {
        return fallback;
      }
      if (typeof value === 'object') {
        return value;
      }
      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    };
    const getMaterialDownloadUrl = file => {
      return toMaterialPreviewFile(file).downloadSource;
    };
    const toMaterialPreviewFile = file => withBlobPreview(normalizeCustomerMaterialFile(file), 'customer-material');
    const getAuthHeaders = () => {
      const userStore = useUserStore();
      const headers = {};
      if (userStore.accessToken) {
        headers.Authorization = `${userStore.tokenType} ${userStore.accessToken}`;
      }
      let deviceId = localStorage.getItem('deviceId');
      if (!deviceId) {
        deviceId = `WEB-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        localStorage.setItem('deviceId', deviceId);
      }
      headers['X-Device-Id'] = deviceId;
      headers['X-Client-Type'] = 'web';
      return headers;
    };
    const downloadBlob = (blob, filename) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'download';
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    };
    const loadMaterialPreviewFile = async (file, options = {}) => {
      const source = options.purpose === 'download' ? file.downloadSource || file.downloadUrl : file.previewSource || file.url;
      const response = await axios.get(source, {
        responseType: 'blob',
        headers: getAuthHeaders()
      });
      return {
        data: response.data,
        contentType: response?.headers?.['content-type'] || response.data?.type || file.contentType
      };
    };

    // Modal control
    const closeModal = () => {
      emit('update:modelValue', false);
    };
    const openEditCustomerModal = () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      emit('edit-customer', customerDetail.value);
    };

    // Data loading
    const loadCompanies = async () => {
      const customerId = customerDetail.value?.id;
      if (!customerId) return;
      isCompanyFetching.value = true;
      try {
        const payload = {
          customerId,
          page: companyPagination.page,
          size: companyPagination.size
        };
        const result = await getCompanyPage(payload);
        companyPagination.page = result?.current || companyPagination.page;
        companyPagination.size = result?.size || companyPagination.size;
        companyPagination.total = result?.total || 0;
        companyPagination.pages = result?.pages || 0;
        relatedEnterprises.value = (result?.records || []).map(mapCompanyFromApi);
      } catch (error) {
        ElMessage.error(error?.message || '获取企业列表失败');
      } finally {
        isCompanyFetching.value = false;
      }
    };
    const loadCustomerProposals = async () => {
      const customerId = customerDetail.value?.id;
      if (!customerId) return;
      isProposalLoading.value = true;
      try {
        const payload = {
          customerId,
          page: proposalPagination.page,
          size: proposalPagination.size
        };
        const result = await getPlanPage(payload);
        proposalPagination.page = result?.current || proposalPagination.page;
        proposalPagination.size = result?.size || proposalPagination.size;
        proposalPagination.total = result?.total || 0;
        proposalPagination.pages = result?.pages || 0;
        customerProposals.value = result?.records || [];
      } catch (error) {
        ElMessage.error(error?.message || '获取方案列表失败');
      } finally {
        isProposalLoading.value = false;
      }
    };
    const fetchCustomerDetail = async id => {
      if (!id) return;
      isCustomerDetailLoading.value = true;
      try {
        const detail = await getCustomer(id);
        customerDetail.value = detail;
        if (props.modelValue && activeDetailTab.value === 'followup' && detail?.id) {
          followupPagination.page = 1;
          await loadFollowupRecords();
          locateHighlightFollow();
        }
      } catch (error) {
        console.error('获取客户详情失败:', error);
      } finally {
        isCustomerDetailLoading.value = false;
      }
    };
    const loadCustomerOrders = async () => {
      const customerId = customerDetail.value?.id;
      if (!customerId) return;
      isOrderLoading.value = true;
      try {
        const payload = {
          customerId,
          page: orderPagination.page,
          size: orderPagination.size
        };
        const result = await getOrderPage(payload);
        orderPagination.page = result?.current || orderPagination.page;
        orderPagination.size = result?.size || orderPagination.size;
        orderPagination.total = result?.total || 0;
        orderPagination.pages = result?.pages || 0;
        customerOrders.value = result?.records || [];
      } catch (error) {
        ElMessage.error(error?.message || '获取订单列表失败');
      } finally {
        isOrderLoading.value = false;
      }
    };
    const loadFollowupRecords = async ({
      append = false
    } = {}) => {
      const customerId = customerDetail.value?.id;
      if (!customerId) return;
      isFollowupFetching.value = true;
      try {
        const payload = {
          customerId,
          page: followupPagination.page,
          size: followupPagination.size
        };
        const result = await getCustomerFollowPage(payload);
        followupPagination.page = result?.current || followupPagination.page;
        followupPagination.size = result?.size || followupPagination.size;
        followupPagination.total = result?.total || 0;
        followupPagination.pages = result?.pages || 0;
        const records = (result?.records || []).map(mapFollowupFromApi);
        followupRecords.value = append ? followupRecords.value.concat(records) : records;
      } catch (error) {
        ElMessage.error(error?.message || '获取跟进记录失败');
      } finally {
        isFollowupFetching.value = false;
      }
    };
    const loadMaterialTypes = async () => {
      if (isMaterialTypesLoading.value) return;
      isMaterialTypesLoading.value = true;
      try {
        const result = await getCustomerMaterialTypes();
        materialTypeCategories.value = Array.isArray(result) ? result : [];
      } catch (error) {
        ElMessage.error(error?.message || '获取资料类型失败');
      } finally {
        isMaterialTypesLoading.value = false;
      }
    };
    const loadCustomerMaterials = async () => {
      const customerId = customerDetail.value?.id;
      if (!customerId) return;
      isMaterialListLoading.value = true;
      try {
        const result = await getCustomerMaterials(customerId);
        customerMaterials.value = Array.isArray(result) ? result : [];
      } catch (error) {
        ElMessage.error(error?.message || '获取客户资料失败');
      } finally {
        isMaterialListLoading.value = false;
      }
    };

    // Material form functions
    const resetMaterialForm = () => {
      materialForm.definitionCode = '';
      materialForm.name = '';
      materialForm.expireDate = '';
      materialForm.visibleToCustomer = false;
      selectedMaterialDefinitionCode.value = '';
      activeMaterialDefinition.value = null;
      materialDetail.value = null;
      materialSchema.value = null;
      materialFileConfig.value = {
        files: []
      };
      Object.keys(materialFormData).forEach(key => delete materialFormData[key]);
      Object.keys(uploadFileStates).forEach(key => delete uploadFileStates[key]);
    };
    const initMaterialFormData = (schema, formDataValue) => {
      const parsed = parseJsonSafely(formDataValue, {});
      Object.keys(materialFormData).forEach(key => delete materialFormData[key]);
      if (schema?.properties) {
        Object.keys(schema.properties).forEach(key => {
          materialFormData[key] = parsed?.[key] ?? schema.properties?.[key]?.default ?? '';
        });
      } else if (parsed && typeof parsed === 'object') {
        Object.assign(materialFormData, parsed);
      }
    };
    const initUploadFileStates = fileConfig => {
      Object.keys(uploadFileStates).forEach(key => delete uploadFileStates[key]);
      const files = fileConfig?.files || [];
      files.forEach(file => {
        uploadFileStates[file.fieldCode] = {
          file: null,
          changeReason: '',
          inputKey: Date.now() + Math.random()
        };
      });
    };
    const loadMaterialDetail = async (definition, materialSummary = null) => {
      if (!definition || !customerDetail.value?.id) return;
      const seq = ++materialDetailRequestSeq;
      materialDetail.value = null;
      const customerId = customerDetail.value.id;
      let detail = null;
      if (materialSummary) {
        try {
          detail = await getCustomerMaterialDetail(customerId, definition.code);
        } catch (error) {
          if (seq === materialDetailRequestSeq) {
            ElMessage.error(error?.message || '获取资料详情失败');
          }
          return;
        }
      }
      // 丢弃旧请求的响应
      if (seq !== materialDetailRequestSeq) return;
      materialDetail.value = detail;
      const schema = parseJsonSafely(definition.formSchema, null);
      const fileConfig = parseJsonSafely(definition.fileConfig, {
        files: []
      });
      materialSchema.value = schema;
      materialFileConfig.value = fileConfig || {
        files: []
      };
      initMaterialFormData(schema, detail?.formData);
      initUploadFileStates(fileConfig);
      materialForm.definitionCode = definition.code;
      materialForm.name = detail?.name || definition.name || '';
      materialForm.expireDate = detail?.expireDate || materialSummary?.expireDate || '';
      materialForm.visibleToCustomer = detail?.visibleToCustomer ?? false;
    };

    /**
     * 根据ID加载资料详情
     */
    const loadMaterialDetailById = async (userMaterialId, definition) => {
      if (!userMaterialId || !definition) return;
      const seq = ++materialDetailRequestSeq;
      materialDetail.value = null;
      try {
        const detail = await getCustomerMaterialDetailById(userMaterialId);
        // 丢弃旧请求的响应
        if (seq !== materialDetailRequestSeq) return;
        materialDetail.value = detail;
        const schema = parseJsonSafely(definition.formSchema, null);
        const fileConfig = parseJsonSafely(definition.fileConfig, {
          files: []
        });
        materialSchema.value = schema;
        materialFileConfig.value = fileConfig || {
          files: []
        };
        initMaterialFormData(schema, detail?.formData);
        initUploadFileStates(fileConfig);
        materialForm.definitionCode = definition.code;
        materialForm.name = detail?.name || definition.name || '';
        materialForm.expireDate = detail?.expireDate || '';
        materialForm.visibleToCustomer = detail?.visibleToCustomer ?? false;
      } catch (error) {
        if (seq === materialDetailRequestSeq) {
          ElMessage.error(error?.message || '获取资料详情失败');
        }
      }
    };
    const openMaterialCreateModal = async () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      await loadMaterialTypes();
      resetMaterialForm();
      materialModalMode.value = 'create';
      showMaterialModal.value = true;
    };
    const openMaterialDetailModal = async (definition, materialSummary = null) => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      await loadMaterialTypes();
      // 从已刷新的 materialDefinitionMap 中获取完整的 definition（包含 formSchema、allowMultiple）
      const fullDefinition = definition?.code ? materialDefinitionMap.value.get(definition.code) : null;
      selectedMaterialDefinitionCode.value = definition?.code || '';
      activeMaterialDefinition.value = fullDefinition || definition || null;
      showMaterialModal.value = true;
      if (materialSummary?.id) {
        // 有已有资料，编辑模式获取详情
        materialModalMode.value = 'edit';
        await loadMaterialDetailById(materialSummary.id, fullDefinition || definition || null);
      } else {
        // 无已有资料，新建模式加载表单
        materialModalMode.value = 'create';
        resetMaterialForm();
        activeMaterialDefinition.value = fullDefinition || definition;
        const schema = parseJsonSafely((fullDefinition || definition)?.formSchema, null);
        const fileConfig = parseJsonSafely((fullDefinition || definition)?.fileConfig, {
          files: []
        });
        materialSchema.value = schema;
        materialFileConfig.value = fileConfig || {
          files: []
        };
        initMaterialFormData(schema, null);
        initUploadFileStates(fileConfig);
        materialForm.definitionCode = (fullDefinition || definition)?.code || '';
        materialForm.name = (fullDefinition || definition)?.name || '';
      }
    };
    const closeMaterialModal = () => {
      showMaterialModal.value = false;
      resetMaterialForm();
    };
    const handleMaterialDefinitionChange = async () => {
      const definition = materialDefinitionMap.value.get(selectedMaterialDefinitionCode.value);
      activeMaterialDefinition.value = definition || null;
      if (!definition) {
        resetMaterialForm();
        showMaterialModal.value = true;
        return;
      }
      // 新建模式：直接加载表单配置
      if (materialModalMode.value === 'create') {
        if (hasMaterialFormData() && !confirm('切换资料类型将丢失已填写的数据，是否继续？')) {
          selectedMaterialDefinitionCode.value = activeMaterialDefinition.value?.code || '';
          return;
        }
        resetMaterialForm();
        activeMaterialDefinition.value = definition;
        const schema = parseJsonSafely(definition.formSchema, null);
        const fileConfig = parseJsonSafely(definition.fileConfig, {
          files: []
        });
        materialSchema.value = schema;
        materialFileConfig.value = fileConfig || {
          files: []
        };
        initMaterialFormData(schema, null);
        initUploadFileStates(fileConfig);
        materialForm.definitionCode = definition.code;
        materialForm.name = definition.name || '';
        return;
      }
      // 编辑模式：检查是否有已有资料
      const summary = materialInstanceMap.value.get(definition.code);
      if (summary?.id) {
        await loadMaterialDetailById(summary.id, definition);
      } else {
        resetMaterialForm();
        activeMaterialDefinition.value = definition;
        const schema = parseJsonSafely(definition.formSchema, null);
        const fileConfig = parseJsonSafely(definition.fileConfig, {
          files: []
        });
        materialSchema.value = schema;
        materialFileConfig.value = fileConfig || {
          files: []
        };
        initMaterialFormData(schema, null);
        initUploadFileStates(fileConfig);
        materialForm.definitionCode = definition.code;
        materialForm.name = definition.name || '';
      }
    };
    const hasMaterialFormData = () => {
      if (materialForm.name) return true;
      if (materialForm.expireDate) return true;
      if (Object.keys(materialFormData).some(key => materialFormData[key] !== '' && materialFormData[key] !== null && materialFormData[key] !== undefined)) return true;
      if (Object.values(uploadFileStates).some(state => state?.file)) return true;
      return false;
    };
    const buildMaterialFilesPayload = () => {
      // 从 materialDetail.files 构建已有文件的提交 payload
      return (materialDetail.value?.files || []).filter(file => file.isLatest).map(file => ({
        fieldCode: file.fieldCode,
        fileKey: file.fileName || '',
        originalName: file.originalName || '',
        fileSize: file.fileSize || 0,
        changeReason: '复用已有文件'
      })).filter(item => item.fieldCode && item.fileKey);
    };
    const validateMaterialForm = () => {
      if (!activeMaterialDefinition.value?.code) {
        ElMessage.warning('请选择资料类型');
        return false;
      }
      if (activeMaterialDefinition.value?.needExpireCheck && !materialForm.expireDate) {
        ElMessage.warning('请填写有效期');
        return false;
      }
      // 校验表单字段必填
      for (const field of materialFormFields.value) {
        if (field.required && (materialFormData[field.key] === '' || materialFormData[field.key] === null || materialFormData[field.key] === undefined)) {
          ElMessage.warning(`请填写${field.label}`);
          return false;
        }
      }
      // 校验文件字段必填
      for (const fileField of materialFileFields.value) {
        if (fileField.required) {
          // 检查已有文件
          const existingFiles = getMaterialFilesByField(fileField.fieldCode);
          // 检查待上传的新文件（新建和编辑都要看）
          const pendingFile = uploadFileStates[fileField.fieldCode]?.file;
          if (!existingFiles?.length && !pendingFile) {
            ElMessage.warning(`请上传${fileField.label || fileField.fieldCode}文件`);
            return false;
          }
        }
      }
      return true;
    };
    const handleSaveMaterial = async () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      if (!validateMaterialForm()) return;
      isMaterialSaving.value = true;
      const isNew = !materialDetail.value?.id;
      const uploadedFiles = [];

      // 先上传所有待上传文件，获取 fileKey
      const uploadTasks = Object.entries(uploadFileStates).filter(([, state]) => state?.file).map(async ([fieldCode, state]) => {
        try {
          const result = await uploadFile(state.file, 'customer_material', 'private');
          if (result?.fileName) {
            uploadedFiles.push({
              fieldCode,
              fileKey: result.fileName,
              originalName: state.file.name,
              fileSize: state.file.size,
              contentType: state.file.type,
              changeReason: state.changeReason || ''
            });
          }
        } catch (error) {
          throw new Error(`文件 ${state.file.name} 上传失败`);
        }
      });
      if (uploadTasks.length > 0) {
        try {
          await Promise.all(uploadTasks);
        } catch (error) {
          isMaterialSaving.value = false;
          ElMessage.error(error.message || '文件上传失败');
          return;
        }
      }

      // 构建提交 payload
      const payload = {
        customerId: customerDetail.value.id,
        definitionCode: activeMaterialDefinition.value.code,
        name: materialForm.name || undefined,
        formData: JSON.stringify(materialFormData || {}),
        expireDate: materialForm.expireDate || undefined,
        visibleToCustomer: materialForm.visibleToCustomer,
        files: uploadedFiles
      };
      // 更新已有资料时，合并已有文件
      if (!isNew) {
        payload.files = [...buildMaterialFilesPayload(), ...uploadedFiles];
        payload.userMaterialId = materialDetail.value.id;
      }
      try {
        const result = await submitCustomerMaterial(payload);
        materialDetail.value = result;
        // 清除所有上传状态
        Object.values(uploadFileStates).forEach(state => {
          state.file = null;
          state.changeReason = '';
          state.inputKey = Date.now() + Math.random();
        });
        ElMessage.success(isNew ? '资料已创建' : '资料已更新');
        await loadCustomerMaterials();
      } catch (error) {
        ElMessage.error(error?.message || '保存资料失败');
      } finally {
        isMaterialSaving.value = false;
      }
    };
    const handleMaterialFileChange = (fieldCode, event) => {
      const file = event?.target?.files?.[0];
      if (!uploadFileStates[fieldCode]) return;
      if (file && !isPreviewableAttachmentFile(file)) {
        ElMessage.warning(`仅支持${PREVIEWABLE_ATTACHMENT_ACCEPT_LABEL}`);
        uploadFileStates[fieldCode].file = null;
        if (event?.target) event.target.value = '';
        return;
      }
      uploadFileStates[fieldCode].file = file || null;
    };
    const setMaterialFileInputRef = fieldCode => el => {
      if (el) {
        materialFileInputRefs[fieldCode] = el;
      } else {
        delete materialFileInputRefs[fieldCode];
      }
    };
    const triggerMaterialFileInput = fieldCode => {
      materialFileInputRefs[fieldCode]?.click();
    };
    const handleUploadMaterialFile = async fieldCode => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      if (!materialDetail.value?.id) {
        ElMessage.warning('请先创建资料');
        return;
      }
      const state = uploadFileStates[fieldCode];
      if (!state?.file) {
        ElMessage.warning('请选择文件');
        return;
      }
      const formData = new FormData();
      formData.append('fieldCode', fieldCode);
      formData.append('file', state.file);
      if (state.changeReason) {
        formData.append('changeReason', state.changeReason);
      }
      try {
        const result = await uploadCustomerMaterialFile(customerDetail.value.id, materialDetail.value.id, formData);
        materialDetail.value = result;
        uploadFileStates[fieldCode].file = null;
        uploadFileStates[fieldCode].changeReason = '';
        uploadFileStates[fieldCode].inputKey = Date.now() + Math.random();
        await loadCustomerMaterials();
        ElMessage.success('文件上传成功');
      } catch (error) {
        ElMessage.error(error?.message || '文件上传失败');
      }
    };
    const getMaterialFilesByField = fieldCode => {
      const files = materialDetail.value?.files || [];
      return files.filter(file => file.fieldCode === fieldCode).sort((a, b) => (b.version || 0) - (a.version || 0));
    };
    const handleDownloadMaterialFile = async file => {
      const url = getMaterialDownloadUrl(file);
      if (!url) {
        ElMessage.error('下载失败，请稍后重试');
        return;
      }
      try {
        const response = await axios.get(url, {
          responseType: 'blob',
          headers: getAuthHeaders()
        });
        downloadBlob(response.data, file?.originalName);
      } catch (error) {
        ElMessage.error('下载失败，请稍后重试');
      }
    };
    const handleDeleteMaterial = () => {
      if (!materialDetail.value?.id) return;
      materialToDelete.value = {
        id: materialDetail.value.id,
        name: materialDetail.value.name || activeMaterialDefinition.value?.name || materialForm.definitionCode
      };
      showDeleteMaterialModal.value = true;
    };
    const confirmDeleteMaterial = async () => {
      if (!materialToDelete.value || !customerDetail.value?.id) return;
      try {
        await deleteCustomerMaterial(customerDetail.value.id, materialToDelete.value.id);
        ElMessage.success('资料已删除');
        showDeleteMaterialModal.value = false;
        materialToDelete.value = null;
        closeMaterialModal();
        await loadCustomerMaterials();
      } catch (error) {
        ElMessage.error(error?.message || '删除资料失败');
      }
    };
    const closeDeleteMaterialModal = () => {
      showDeleteMaterialModal.value = false;
      materialToDelete.value = null;
    };
    const handleDeleteMaterialFile = file => {
      if (!materialDetail.value?.id || !file?.id) return;
      materialFileToDelete.value = file;
      showDeleteMaterialFileModal.value = true;
    };
    const confirmDeleteMaterialFile = async () => {
      if (!materialDetail.value?.id || !materialFileToDelete.value?.id) return;
      try {
        await deleteCustomerMaterialFile(materialDetail.value.id, materialFileToDelete.value.id);
        ElMessage.success('文件已删除');
        showDeleteMaterialFileModal.value = false;
        materialFileToDelete.value = null;
        if (activeMaterialDefinition.value) {
          await loadMaterialDetail(activeMaterialDefinition.value, materialInstanceMap.value.get(activeMaterialDefinition.value.code));
        }
        await loadCustomerMaterials();
      } catch (error) {
        ElMessage.error(error?.message || '删除文件失败');
      }
    };
    const closeDeleteMaterialFileModal = () => {
      showDeleteMaterialFileModal.value = false;
      materialFileToDelete.value = null;
    };

    // Event handlers
    const openAddEnterpriseModal = () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      emit('open-add-enterprise');
    };
    const openEditEnterpriseModal = company => {
      emit('open-edit-enterprise', company);
    };
    const handleDeleteCompany = company => {
      emit('delete-company', company);
    };

    // Plan detail modal
    const openPlanDetailModal = plan => {
      planDetail.value = plan;
      showPlanDetailModal.value = true;
    };

    // Order detail modal
    const openOrderDetailModal = async order => {
      try {
        orderDetail.value = await getOrderDetail(order.id);
        orderTraceList.value = await getTraceList('ORDER', order.id);
        showOrderDetailModal.value = true;
      } catch (error) {
        ElMessage.error('加载订单详情失败');
      }
    };
    const handleCustomerOrderDetailRefresh = async () => {
      if (!orderDetail.value?.id) {
        return;
      }
      try {
        orderDetail.value = await getOrderDetail(orderDetail.value.id);
        orderTraceList.value = await getTraceList('ORDER', orderDetail.value.id);
        await loadCustomerOrders();
      } catch (error) {
        ElMessage.error(error?.message || '刷新订单详情失败');
      }
    };
    const openOrderPlanDetail = order => {
      planDetail.value = order?.planId ? {
        id: order.planId
      } : null;
      showPlanDetailModal.value = true;
    };
    const openCustomerOrderEditModal = async order => {
      try {
        editOrderData.value = await getOrderDetail(order.id);
        showOrderEditModal.value = true;
      } catch (error) {
        ElMessage.error('加载订单详情失败');
      }
    };
    const handleCustomerOrderDetailEdit = order => {
      editOrderData.value = order;
      showOrderDetailModal.value = false;
      showOrderEditModal.value = true;
    };
    const handleCustomerOrderStatusChange = async ({
      order,
      status
    }) => {
      try {
        await updateOrderStatus({
          orderId: order.id,
          status
        });
        ElMessage.success('状态更新成功');
        await loadCustomerOrders();
      } catch (error) {
        ElMessage.error(error?.message || '状态更新失败');
      }
    };
    const handleOrderPageChange = page => {
      if (page < 1 || page > orderPagination.pages) return;
      orderPagination.page = page;
      loadCustomerOrders();
    };
    const handleOrderPageSizeChange = size => {
      orderPagination.size = size;
      orderPagination.page = 1;
      loadCustomerOrders();
    };
    const isAmountApprovalInProgress = order => {
      return Number(order?.pendingApprovalStatus) === 0 && order?.pendingApprovalInstanceId != null;
    };
    const handleCustomerOrderSuccess = async result => {
      ElMessage.success(isAmountApprovalInProgress(result) ? '已提交订单金额变更审批，审批通过后生效' : '订单修改成功');
      showOrderEditModal.value = false;
      await loadCustomerOrders();
      if (orderDetail.value?.id) {
        orderDetail.value = await getOrderDetail(orderDetail.value.id);
      }
    };
    const openCustomerOrderReceiveModal = billing => {
      selectedBilling.value = billing;
      receiveFormData.paidAmount = receiveRemainingAmount.value;
      receiveFormData.payChannel = '';
      showBillingReceiveModal.value = true;
    };
    const closeCustomerOrderReceiveModal = () => {
      showBillingReceiveModal.value = false;
    };
    const handleCustomerOrderReceiveSubmit = async () => {
      try {
        await receiveFormRef.value.validate();
      } catch {
        return;
      }
      receiveSubmitting.value = true;
      try {
        await receiveBilling({
          billingId: selectedBilling.value.id,
          paidAmount: receiveFormData.paidAmount,
          payChannel: receiveFormData.payChannel
        });
        ElMessage.success('收款成功');
        closeCustomerOrderReceiveModal();
        if (orderDetail.value?.id) {
          orderDetail.value = await getOrderDetail(orderDetail.value.id);
        }
      } catch (error) {
        ElMessage.error(error?.message || '收款失败');
      } finally {
        receiveSubmitting.value = false;
      }
    };

    // 任务状态改为已完成时，自动将进度同步为 100%
    const handleTaskStatusChange = val => {
      if (val === 2 && taskFormData.progress < 100) {
        taskFormData.progress = 100;
      }
    };
    const openCustomerOrderTaskEditModal = task => {
      selectedTask.value = task;
      taskFormData.status = task.status ?? 0;
      taskFormData.progress = task.progress || 0;
      taskFormData.remark = task.remark || '';
      showTaskEditModal.value = true;
    };
    const closeCustomerOrderTaskEditModal = () => {
      showTaskEditModal.value = false;
      if (taskFormRef.value) {
        taskFormRef.value.resetFields();
      }
    };
    const handleCustomerOrderTaskSubmit = async () => {
      try {
        await taskFormRef.value.validate();
      } catch {
        return;
      }
      taskSubmitting.value = true;
      try {
        await updateTask({
          id: selectedTask.value.id,
          orderId: selectedTask.value.orderId,
          status: taskFormData.status,
          progress: taskFormData.progress,
          remark: taskFormData.remark
        });
        ElMessage.success('任务更新成功');
        closeCustomerOrderTaskEditModal();
        if (orderDetail.value?.id) {
          orderDetail.value = await getOrderDetail(orderDetail.value.id);
        }
      } catch (error) {
        ElMessage.error(error?.message || '任务更新失败');
      } finally {
        taskSubmitting.value = false;
      }
    };
    const handleCustomerOrderExecutorChanged = async () => {
      await handleCustomerOrderDetailRefresh();
    };

    // Proposal form modal
    const openProposalFormModal = () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      isProposalEdit.value = false;
      proposalFormCurrentPlan.value = null;
      showProposalFormModal.value = true;
    };
    const openProposalEditModal = plan => {
      isProposalEdit.value = true;
      proposalFormCurrentPlan.value = plan;
      showProposalFormModal.value = true;
    };
    const handleProposalSuccess = () => {
      // 刷新方案列表
      isProposalEdit.value = false;
      proposalFormCurrentPlan.value = null;
      loadCustomerProposals();
    };
    const handleProposalPageChange = page => {
      if (page < 1 || page > proposalPagination.pages) return;
      proposalPagination.page = page;
      loadCustomerProposals();
    };
    const handleProposalPageSizeChange = size => {
      proposalPagination.size = size;
      proposalPagination.page = 1;
      loadCustomerProposals();
    };

    // Approval detail modal
    const openApprovalDetailModal = plan => {
      if (!plan.approvalInstanceId) {
        ElMessage.warning('该方案暂无审批实例');
        return;
      }
      selectedApprovalType.value = 'proposal';
      selectedApprovalInstanceId.value = plan.approvalInstanceId;
      showApprovalDetailModal.value = true;
    };
    const openOrderApprovalDetailModal = order => {
      if (!order?.pendingApprovalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      selectedApprovalType.value = 'order';
      selectedApprovalInstanceId.value = order.pendingApprovalInstanceId;
      showApprovalDetailModal.value = true;
    };
    const openCustomerApprovalDetailModal = () => {
      if (!customerDetail.value?.pendingApprovalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      selectedApprovalType.value = 'customer';
      selectedApprovalInstanceId.value = customerDetail.value.pendingApprovalInstanceId;
      showApprovalDetailModal.value = true;
    };

    // Followup event handlers
    const openFollowupModal = () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      Object.assign(followupForm, {
        id: null,
        type: '电话',
        content: '',
        duration: '',
        nextDate: '',
        followTime: ''
      });
      showFollowupModal.value = true;
    };
    const openEditFollowupModal = record => {
      mapFollowupToForm(record || {});
      showFollowupModal.value = true;
    };
    const handleDeleteFollowup = record => {
      if (!record?.id) return;
      followupToDelete.value = record;
      showDeleteFollowupModal.value = true;
    };
    const handleSubmitFollowup = async () => {
      if (!customerDetail.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      if (!followupForm.content?.trim()) {
        ElMessage.warning('请输入跟进内容');
        return;
      }
      isFollowupSubmitting.value = true;
      try {
        if (followupForm.id) {
          const payload = buildFollowupPayload({
            isUpdate: true
          });
          await updateCustomerFollow({
            ...payload,
            id: followupForm.id
          });
          ElMessage.success('更新成功');
        } else {
          const payload = buildFollowupPayload();
          await createCustomerFollow(payload);
          ElMessage.success('创建成功');
        }
        showFollowupModal.value = false;
        followupPagination.page = 1;
        await loadFollowupRecords();
      } catch (error) {
        ElMessage.error(error?.message || '操作失败');
      } finally {
        isFollowupSubmitting.value = false;
      }
    };
    const confirmDeleteFollowup = async () => {
      const target = followupToDelete.value;
      if (!target?.id) return;
      try {
        await deleteCustomerFollow(target.id);
        ElMessage.success('删除成功');
        showDeleteFollowupModal.value = false;
        followupToDelete.value = null;
        followupPagination.page = 1;
        await loadFollowupRecords();
      } catch (error) {
        ElMessage.error(error?.message || '删除失败');
      }
    };
    const followRowRefs = {};
    const setFollowRowRef = (id, el) => {
      if (el) followRowRefs[id] = el;else delete followRowRefs[id];
    };
    const isHighlightFollow = record => {
      return props.highlightFollowId != null && String(record.id) === String(props.highlightFollowId);
    };
    let locatingHighlight = false;
    const locateHighlightFollow = async () => {
      if (!props.highlightFollowId || locatingHighlight) return;
      const targetId = String(props.highlightFollowId);
      locatingHighlight = true;
      try {
        for (;;) {
          const found = followupRecords.value.find(record => String(record.id) === targetId);
          if (found) {
            await nextTick();
            const el = followRowRefs[found.id];
            if (el?.scrollIntoView) el.scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            });
            return;
          }
          if (!followupPagination.pages || followupPagination.page >= followupPagination.pages) {
            return;
          }
          followupPagination.page += 1;
          await loadFollowupRecords({
            append: true
          });
        }
      } finally {
        locatingHighlight = false;
      }
    };
    const handleDetailScroll = event => {
      if (activeDetailTab.value !== 'followup') return;
      if (isFollowupFetching.value) return;
      if (followupPagination.page >= followupPagination.pages) return;
      const target = event?.target;
      if (!target) return;
      const threshold = 40;
      const isBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - threshold;
      if (!isBottom) return;
      followupPagination.page += 1;
      loadFollowupRecords({
        append: true
      });
    };

    // Watchers
    watch(() => props.modelValue, val => {
      if (val) {
        const firstVisible = visibleDetailTabs.value[0]?.value || 'basic';
        activeDetailTab.value = visibleDetailTabs.value.some(t => t.value === props.initialTab) ? props.initialTab : firstVisible;
        companyPagination.page = 1;
        companyPagination.total = 0;
        companyPagination.pages = 0;
        relatedEnterprises.value = [];
        followupPagination.page = 1;
        followupPagination.total = 0;
        followupPagination.pages = 0;
        followupRecords.value = [];
      }
    });
    watch(() => props.customer?.id, customerId => {
      if (customerId) {
        customerDetail.value = null;
        fetchCustomerDetail(customerId);
      }
    });
    watch([activeDetailTab, () => props.customer], async ([tab]) => {
      if (tab === 'enterprises' && customerDetail.value?.id) {
        companyPagination.page = 1;
        loadCompanies();
        return;
      }
      if (tab === 'proposals') {
        proposalPagination.page = 1;
        loadCustomerProposals();
        return;
      }
      if (tab === 'orders') {
        orderPagination.page = 1;
        loadCustomerOrders();
        return;
      }
      if (tab === 'documents') {
        loadMaterialTypes();
        loadCustomerMaterials();
        return;
      }
      if (tab === 'followup') {
        followupPagination.page = 1;
        await loadFollowupRecords();
        locateHighlightFollow();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(AppModal, {
        visible: __props.modelValue,
        size: "none",
        "panel-class": "max-w-screen-2xl",
        scrollable: false,
        onClose: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(['w-12 h-12 rounded-full flex items-center justify-center', customerDetail.value?.type === '企业' ? 'bg-purple-100' : 'bg-green-100'])
        }, [customerDetail.value?.type === '企业' ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[24] || (_cache[24] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[25] || (_cache[25] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        }, null, -1)]))]))], 2), _createElementVNode("div", null, [_createElementVNode("h3", _hoisted_5, _toDisplayString(customerDetail.value?.name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
          class: _normalizeClass(['px-2 py-0.5 rounded text-xs', getTypeClass(customerDetail.value?.type)])
        }, _toDisplayString(customerDetail.value?.type), 3), customerDetail.value?.isKey ? (_openBlock(), _createElementBlock("span", _hoisted_7, "重点客户")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_8, _toDisplayString(customerDetail.value?.source), 1)])])]), _createElementVNode("button", {
          onClick: closeModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("nav", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDetailTabs.value, tab => {
          return _openBlock(), _createElementBlock("button", {
            key: tab.value,
            onClick: $event => activeDetailTab.value = tab.value,
            class: _normalizeClass(['w-full px-4 py-2.5 text-left text-sm font-medium transition-colors flex items-center gap-2', activeDetailTab.value === tab.value ? 'bg-white text-primary-600 border-r-2 border-primary-500' : 'text-slate-600 hover:bg-slate-100'])
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), {
            class: "w-4 h-4"
          })), _createTextVNode(" " + _toDisplayString(tab.label), 1)], 10, _hoisted_12);
        }), 128))])]), _createElementVNode("div", {
          ref_key: "detailContentRef",
          ref: detailContentRef,
          class: "flex-1 overflow-y-auto p-6",
          onScroll: handleDetailScroll
        }, [activeDetailTab.value === 'basic' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[28] || (_cache[28] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "客户基本信息", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: openEditCustomerModal,
          class: "table-action-button is-primary",
          title: "编辑",
          "aria-label": "编辑"
        }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)]))])), [[_directive_permission, 'customer:edit']])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[29] || (_cache[29] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "性别", -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(customerDetail.value?.gender === 0 ? '男' : customerDetail.value?.gender === 1 ? '女' : '-'), 1)]), _createElementVNode("div", _hoisted_18, [_cache[30] || (_cache[30] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "联系电话", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString(customerDetail.value?.phone), 1)]), _createElementVNode("div", _hoisted_20, [_cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "备用电话", -1)), _createElementVNode("div", _hoisted_21, _toDisplayString(customerDetail.value?.altPhone || '-'), 1)]), _createElementVNode("div", _hoisted_22, [_cache[32] || (_cache[32] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "身份证号", -1)), _createElementVNode("div", _hoisted_23, _toDisplayString(customerDetail.value?.idCard ? customerDetail.value.idCard.replace(/(\d{4})\d+(\d{4})/, '$1**********$2') : '-'), 1)]), _createElementVNode("div", _hoisted_24, [_cache[33] || (_cache[33] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "客户邮箱", -1)), _createElementVNode("div", _hoisted_25, _toDisplayString(customerDetail.value?.email || '-'), 1)]), _createElementVNode("div", _hoisted_26, [_cache[34] || (_cache[34] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "客户等级", -1)), _createElementVNode("div", _hoisted_27, _toDisplayString(customerDetail.value?.level || '普通'), 1)]), _createElementVNode("div", _hoisted_28, [_cache[35] || (_cache[35] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "客户来源", -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(customerDetail.value?.source || '-'), 1)]), _createElementVNode("div", _hoisted_30, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "所属规划师", -1)), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(customerDetail.value?.salesPerson || customerDetail.value?.ownerUser?.displayName || customerDetail.value?.ownerUserName || '未分配'), 1), hasCustomerPendingApproval.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-purple",
          title: "查看审批详情",
          "aria-label": "查看审批详情",
          onClick: _withModifiers(openCustomerApprovalDetailModal, ["stop"])
        }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        })], -1)]))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_33, [_cache[38] || (_cache[38] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "注册时间", -1)), _createElementVNode("div", _hoisted_34, _toDisplayString(customerDetail.value?.createdAt || '-'), 1)]), _createElementVNode("div", _hoisted_35, [_cache[39] || (_cache[39] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "累计消费", -1)), _createElementVNode("div", _hoisted_36, "¥" + _toDisplayString((customerDetail.value?.totalSpent || 0).toLocaleString()), 1)]), _createElementVNode("div", _hoisted_37, [_cache[40] || (_cache[40] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "所在地区", -1)), _createElementVNode("div", _hoisted_38, _toDisplayString(customerDetail.value?.address || ''), 1)]), _createElementVNode("div", _hoisted_39, [_cache[41] || (_cache[41] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "详细住址", -1)), _createElementVNode("div", _hoisted_40, _toDisplayString(customerDetail.value?.detailAddress || '-'), 1)]), _createElementVNode("div", _hoisted_41, [_cache[42] || (_cache[42] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "标签", -1)), _createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedTags.value, tag => {
          return _openBlock(), _createElementBlock("span", {
            key: tag,
            class: "px-2 py-0.5 rounded text-xs bg-primary-50 text-primary-700 border border-primary-200"
          }, _toDisplayString(tag), 1);
        }), 128)), !parsedTags.value.length ? (_openBlock(), _createElementBlock("span", _hoisted_43, "暂无标签")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_44, [_cache[43] || (_cache[43] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "备注信息", -1)), _createElementVNode("div", _hoisted_45, _toDisplayString(customerDetail.value?.remark || '暂无备注'), 1)])])])) : _createCommentVNode("", true), activeDetailTab.value === 'enterprises' ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[45] || (_cache[45] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "关联企业列表", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: openAddEnterpriseModal,
          class: "flex items-center gap-2 px-3 py-1.5 bg-primary-50 text-primary-600 rounded-lg hover:bg-primary-100 text-sm"
        }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 添加关联企业 ", -1)]))])), [[_directive_permission, 'customer:company:add']])]), !relatedEnterprises.value.length && !isCompanyFetching.value ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 暂无关联企业 ")) : (_openBlock(), _createElementBlock("div", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedEnterprises.value, ent => {
          return _openBlock(), _createElementBlock("div", {
            key: ent.id,
            class: "border border-slate-200 rounded-lg overflow-hidden"
          }, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[46] || (_cache[46] = _createElementVNode("div", {
            class: "w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 text-purple-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          })])], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_52, _toDisplayString(ent.name), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(ent.relation), 1)])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs', ent.status === 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'])
          }, _toDisplayString(ent.statusLabel), 3), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _withModifiers($event => openEditEnterpriseModal(ent), ["stop"]),
            class: "px-2 py-0.5 text-xs border border-slate-200 rounded text-slate-600 hover:bg-white"
          }, [...(_cache[47] || (_cache[47] = [_createTextVNode("编辑", -1)]))], 8, _hoisted_55)), [[_directive_permission, 'customer:company:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _withModifiers($event => handleDeleteCompany(ent), ["stop"]),
            class: "px-2 py-0.5 text-xs border border-red-200 rounded text-red-600 hover:bg-red-50"
          }, [...(_cache[48] || (_cache[48] = [_createTextVNode("删除", -1)]))], 8, _hoisted_56)), [[_directive_permission, 'customer:company:delete']])])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_cache[49] || (_cache[49] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-1"
          }, "社会统一信用代码", -1)), _createElementVNode("div", _hoisted_60, _toDisplayString(ent.creditCode || '-'), 1)]), _createElementVNode("div", _hoisted_61, [_cache[50] || (_cache[50] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-1"
          }, "法人代表", -1)), _createElementVNode("div", _hoisted_62, _toDisplayString(ent.legalPerson || '-'), 1)]), _createElementVNode("div", _hoisted_63, [_cache[51] || (_cache[51] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-1"
          }, "注册资本", -1)), _createElementVNode("div", _hoisted_64, _toDisplayString(ent.registeredCapital || '-'), 1)]), _createElementVNode("div", _hoisted_65, [_cache[52] || (_cache[52] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-1"
          }, "成立日期", -1)), _createElementVNode("div", _hoisted_66, _toDisplayString(ent.establishedDate || '-'), 1)]), _createElementVNode("div", _hoisted_67, [_cache[53] || (_cache[53] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-1"
          }, "企业经营地址", -1)), _createElementVNode("div", _hoisted_68, _toDisplayString(ent.companyAddress || '-'), 1)]), _createElementVNode("div", _hoisted_69, [_cache[54] || (_cache[54] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-1"
          }, "经营范围", -1)), _createElementVNode("div", _hoisted_70, _toDisplayString(ent.businessScope || '-'), 1)])])])]);
        }), 128))]))])) : _createCommentVNode("", true), activeDetailTab.value === 'proposals' ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_cache[56] || (_cache[56] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "客户方案列表", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: openProposalFormModal,
          class: "flex items-center gap-2 px-3 py-1.5 bg-primary-50 text-primary-600 rounded-lg hover:bg-primary-100 text-sm"
        }, [...(_cache[55] || (_cache[55] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新建方案 ", -1)]))])), [[_directive_permission, 'plan:save']])]), _createVNode(ProposalListTable, {
          plans: customerProposals.value,
          loading: isProposalLoading.value,
          pagination: proposalPagination,
          "customer-linkable": false,
          "compact-empty": "",
          onDetail: openPlanDetailModal,
          onEdit: openProposalEditModal,
          onApprovalDetail: openApprovalDetailModal,
          onPageChange: handleProposalPageChange,
          onSizeChange: handleProposalPageSizeChange
        }, null, 8, ["plans", "loading", "pagination"])])) : _createCommentVNode("", true), activeDetailTab.value === 'orders' ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_cache[67] || (_cache[67] = _createElementVNode("div", {
          class: "flex justify-between items-center"
        }, [_createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "订单记录")], -1)), _createVNode(OrderListTable, {
          orders: customerOrders.value,
          loading: isOrderLoading.value,
          pagination: orderPagination,
          "show-plan-column": true,
          "show-customer-column": false,
          "show-company-column": false,
          "show-edit-action": true,
          "show-status-action": true,
          "show-pagination": true,
          "edit-permission": null,
          "status-edit-permission": null,
          "compact-empty": "",
          onDetail: openOrderDetailModal,
          onPlanClick: openOrderPlanDetail,
          onEdit: openCustomerOrderEditModal,
          onApprovalDetail: openOrderApprovalDetailModal,
          onStatusChange: handleCustomerOrderStatusChange,
          onPageChange: handleOrderPageChange,
          onSizeChange: handleOrderPageSizeChange
        }, null, 8, ["orders", "loading", "pagination"]), false ? (_openBlock(), _createElementBlock("div", _hoisted_74, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
          return _createElementVNode("div", {
            key: n,
            class: "flex items-center gap-4 p-4 bg-slate-50 rounded-lg"
          }, [...(_cache[57] || (_cache[57] = [_createElementVNode("div", {
            class: "w-10 h-10 bg-slate-200 rounded-lg animate-pulse"
          }, null, -1), _createElementVNode("div", {
            class: "flex-1"
          }, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded animate-pulse mb-2"
          }), _createElementVNode("div", {
            class: "h-3 w-24 bg-slate-200 rounded animate-pulse"
          })], -1), _createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded animate-pulse"
          }, null, -1), _createElementVNode("div", {
            class: "h-6 w-16 bg-slate-200 rounded-full animate-pulse"
          }, null, -1)]))]);
        }), 64))])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_75, " 暂无订单数据 ")) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_createElementVNode("table", _hoisted_77, [_cache[61] || (_cache[61] = _createElementVNode("thead", {
          class: "bg-slate-50"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
        }, "订单信息"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
        }, "所属方案"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
        }, "规划师"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
        }, "执行人"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500"
        }, "服务周期"), _createElementVNode("th", {
          class: "px-4 py-3 text-right text-xs font-medium text-slate-500"
        }, "订单金额"), _createElementVNode("th", {
          class: "px-4 py-3 text-center text-xs font-medium text-slate-500"
        }, "状态"), _createElementVNode("th", {
          class: "px-4 py-3 text-center text-xs font-medium text-slate-500"
        }, "创建时间"), _createElementVNode("th", {
          class: "px-4 py-3 text-center text-xs font-medium text-slate-500"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_78, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerOrders.value, order => {
          return _openBlock(), _createElementBlock("tr", {
            key: order.id,
            class: "hover:bg-slate-50"
          }, [_createElementVNode("td", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_cache[58] || (_cache[58] = _createElementVNode("div", {
            class: "w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 text-blue-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })])], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_81, _toDisplayString(order.productNameSnapshot), 1), _createElementVNode("div", _hoisted_82, _toDisplayString(order.orderNo), 1)])])]), _createElementVNode("td", _hoisted_83, [order.planName ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(order.planName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_85, "-"))]), _createElementVNode("td", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_cache[59] || (_cache[59] = _createElementVNode("div", {
            class: "w-6 h-6 bg-primary-50 rounded-full flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-3 h-3 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })])], -1)), _createElementVNode("span", null, _toDisplayString(order.ownerUserName || '-'), 1)])]), _createElementVNode("td", _hoisted_88, _toDisplayString(order.executorName || '-'), 1), _createElementVNode("td", _hoisted_89, _toDisplayString(order.serviceStart) + " ~ " + _toDisplayString(order.serviceEnd), 1), _createElementVNode("td", _hoisted_90, "¥" + _toDisplayString(order.amount?.toLocaleString() || '0'), 1), _createElementVNode("td", _hoisted_91, [_createElementVNode("span", {
            class: _normalizeClass(['px-2 py-1 rounded-full text-xs font-medium', orderStatusMap[order.status]?.class || 'bg-slate-100 text-slate-600'])
          }, _toDisplayString(orderStatusMap[order.status]?.text || '未知'), 3)]), _createElementVNode("td", _hoisted_92, _toDisplayString(order.createTime?.replace('T', ' ').slice(0, 19) || '-'), 1), _createElementVNode("td", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("button", {
            onClick: $event => openOrderDetailModal(order),
            class: "p-1.5 text-slate-400 hover:text-primary-600 hover:bg-primary-50 rounded transition-colors",
            title: "查看详情"
          }, [...(_cache[60] || (_cache[60] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_95)])])]);
        }), 128))])])])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_createElementVNode("span", null, [_cache[62] || (_cache[62] = _createTextVNode("共 ", -1)), _createElementVNode("span", _hoisted_97, _toDisplayString(orderPagination.total), 1), _cache[63] || (_cache[63] = _createTextVNode(" 条", -1))]), _createElementVNode("span", null, [_cache[64] || (_cache[64] = _createTextVNode("第 ", -1)), _createElementVNode("span", _hoisted_98, _toDisplayString(orderPagination.page), 1), _cache[65] || (_cache[65] = _createTextVNode(" / ", -1)), _createElementVNode("span", _hoisted_99, _toDisplayString(orderPagination.pages), 1), _cache[66] || (_cache[66] = _createTextVNode(" 页", -1))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeDetailTab.value === 'documents' ? (_openBlock(), _createElementBlock("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_cache[69] || (_cache[69] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "客户资料库", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: openMaterialCreateModal,
          class: "flex items-center gap-2 px-3 py-1.5 bg-primary-50 text-primary-600 rounded-lg hover:bg-primary-100 text-sm"
        }, [...(_cache[68] || (_cache[68] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
        })], -1), _createTextVNode(" 上传资料 ", -1)]))])), [[_directive_permission, 'customer:material:add']])]), isMaterialTypesLoading.value || isMaterialListLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_102, " 正在加载资料配置... ")) : !materialCategoryDisplays.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_103, " 暂无资料配置 ")) : (_openBlock(), _createElementBlock("div", _hoisted_104, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialCategoryDisplays.value, category => {
          return _openBlock(), _createElementBlock("div", {
            key: category.categoryCode,
            class: "space-y-3"
          }, [_createElementVNode("h5", _hoisted_105, [_cache[70] || (_cache[70] = _createElementVNode("span", {
            class: "inline-flex h-2 w-2 rounded-full bg-primary-500"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(category.categoryName), 1)]), _createElementVNode("div", _hoisted_106, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.definition.code,
              class: "border border-slate-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer",
              onClick: $event => openMaterialDetailModal(item.definition, item.material)
            }, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_createElementVNode("span", null, _toDisplayString(item.material?.name || item.definition.name), 1), item.definition.isRequired ? (_openBlock(), _createElementBlock("span", _hoisted_111, "必填")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_112, [item.material?.name ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(item.definition.name), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(item.definition.nameAlias || item.definition.description || '无描述'), 1))])]), _createElementVNode("div", {
              class: _normalizeClass(['px-2 py-0.5 rounded text-xs', item.material ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'])
            }, _toDisplayString(item.material ? '已建立' : '未建立'), 3)]), _createElementVNode("div", _hoisted_115, [_createElementVNode("div", null, "文件数: " + _toDisplayString(item.material?.fileCount || 0), 1), item.definition.needExpireCheck ? (_openBlock(), _createElementBlock("div", _hoisted_116, " 有效期: " + _toDisplayString(formatDate(item.material?.expireDate)), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, "最后上传: " + _toDisplayString(formatDateTime(item.material?.lastUploadTime)), 1)]), _createElementVNode("div", _hoisted_117, [_withDirectives((_openBlock(), _createElementBlock("button", {
              class: "w-full px-2 py-1.5 text-xs bg-primary-50 text-primary-600 rounded hover:bg-primary-100",
              onClick: _withModifiers($event => openMaterialDetailModal(item.definition, item.material), ["stop"])
            }, [...(_cache[71] || (_cache[71] = [_createTextVNode(" 编辑/上传 ", -1)]))], 8, _hoisted_118)), [[_directive_permission, 'customer:material:add']])])], 8, _hoisted_107);
          }), 128))])]);
        }), 128))]))])) : _createCommentVNode("", true), activeDetailTab.value === 'followup' ? (_openBlock(), _createElementBlock("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, [_cache[73] || (_cache[73] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "客户日志", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[0] || (_cache[0] = $event => openFollowupModal(__props.customer)),
          class: "flex items-center gap-2 px-3 py-1.5 bg-primary-50 text-primary-600 rounded-lg hover:bg-primary-100 text-sm"
        }, [...(_cache[72] || (_cache[72] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 添加客户日志 ", -1)]))])), [[_directive_permission, 'customer:follow:add']])]), !followupRecords.value.length && !isFollowupFetching.value ? (_openBlock(), _createElementBlock("div", _hoisted_121, " 暂无客户日志 ")) : (_openBlock(), _createElementBlock("div", _hoisted_122, [_cache[76] || (_cache[76] = _createElementVNode("div", {
          class: "absolute left-4 top-0 bottom-0 w-0.5 bg-slate-200"
        }, null, -1)), _createElementVNode("div", _hoisted_123, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followupRecords.value, record => {
          return _openBlock(), _createElementBlock("div", {
            key: record.id,
            ref_for: true,
            ref: el => setFollowRowRef(record.id, el),
            class: _normalizeClass(['relative pl-10', isHighlightFollow(record) ? 'follow-highlight' : ''])
          }, [_createElementVNode("div", {
            class: _normalizeClass(['absolute left-2.5 w-3 h-3 rounded-full border-2 bg-white', getFollowupIconClass(record.type)])
          }, null, 2), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, [_createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', getFollowupTypeClass(record.type)])
          }, _toDisplayString(record.type), 3), _createElementVNode("span", _hoisted_127, _toDisplayString(record.duration ? `${record.duration}分钟` : '-'), 1)]), _createElementVNode("div", _hoisted_128, [_createElementVNode("span", _hoisted_129, _toDisplayString(record.date || '-'), 1), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openEditFollowupModal(record),
            class: "p-0.5 text-slate-400 hover:text-primary-600 hover:bg-primary-50 rounded",
            title: "编辑"
          }, [...(_cache[74] || (_cache[74] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_130)), [[_directive_permission, 'customer:follow:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDeleteFollowup(record),
            class: "p-0.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded",
            title: "删除"
          }, [...(_cache[75] || (_cache[75] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3m-4 0h14"
          })], -1)]))], 8, _hoisted_131)), [[_directive_permission, 'customer:follow:delete']])])]), _createElementVNode("p", _hoisted_132, _toDisplayString(record.content), 1), _createElementVNode("div", _hoisted_133, [_createElementVNode("span", null, "跟进人: " + _toDisplayString(record.operator || '-'), 1), record.nextDate ? (_openBlock(), _createElementBlock("span", _hoisted_134, "下次跟进: " + _toDisplayString(record.nextDate), 1)) : _createCommentVNode("", true)])])], 2);
        }), 128))])]))])) : _createCommentVNode("", true)], 544)]), _createVNode(AppModal, {
          visible: showMaterialModal.value,
          size: "5xl",
          scrollable: false,
          "z-index": 60,
          onClose: closeMaterialModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_135, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_136, _toDisplayString(activeMaterialDefinition.value?.name || '资料维护'), 1), _createElementVNode("p", _hoisted_137, _toDisplayString(activeMaterialDefinition.value?.nameAlias || activeMaterialDefinition.value?.description || '请选择资料类型'), 1)]), _createElementVNode("button", {
            onClick: closeMaterialModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[77] || (_cache[77] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_138, [_createElementVNode("div", _hoisted_139, [_createElementVNode("div", null, [_cache[79] || (_cache[79] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("资料类型 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedMaterialDefinitionCode.value = $event),
            onChange: handleMaterialDefinitionChange,
            class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          }, [_cache[78] || (_cache[78] = _createElementVNode("option", {
            value: ""
          }, "请选择资料类型", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialTypeCategories.value, category => {
            return _openBlock(), _createElementBlock("optgroup", {
              key: category.categoryCode,
              label: category.categoryName
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.materialDefinitions, definition => {
              return _openBlock(), _createElementBlock("option", {
                key: definition.code,
                value: definition.code
              }, _toDisplayString(definition.name), 9, _hoisted_141);
            }), 128))], 8, _hoisted_140);
          }), 128))], 544), [[_vModelSelect, selectedMaterialDefinitionCode.value]])]), _createElementVNode("div", null, [_cache[80] || (_cache[80] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "资料名称", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => materialForm.name = $event),
            type: "text",
            class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
            placeholder: "请输入资料名称（默认使用类型名称）"
          }, null, 512), [[_vModelText, materialForm.name]])]), activeMaterialDefinition.value?.needExpireCheck ? (_openBlock(), _createElementBlock("div", _hoisted_142, [_cache[81] || (_cache[81] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("有效期 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: materialForm.expireDate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => materialForm.expireDate = $event),
            type: "date",
            class: "w-full",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择有效期"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[83] || (_cache[83] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "客户可见", -1)), _createElementVNode("div", _hoisted_143, [_createElementVNode("label", _hoisted_144, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "form-switch-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => materialForm.visibleToCustomer = $event)
          }, null, 512), [[_vModelCheckbox, materialForm.visibleToCustomer]]), _cache[82] || (_cache[82] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))]), _createElementVNode("span", _hoisted_145, _toDisplayString(materialForm.visibleToCustomer ? '是' : '否'), 1)])])]), materialFormFields.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_146, [_cache[86] || (_cache[86] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-3"
          }, "表单信息", -1)), _createElementVNode("div", _hoisted_147, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialFormFields.value, field => {
            return _openBlock(), _createElementBlock("div", {
              key: field.key
            }, [_createElementVNode("label", _hoisted_148, [_createTextVNode(_toDisplayString(field.label) + " ", 1), field.required ? (_openBlock(), _createElementBlock("span", _hoisted_149, "*")) : _createCommentVNode("", true)]), field.enum ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            }, [_cache[84] || (_cache[84] = _createElementVNode("option", {
              value: ""
            }, "请选择", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.enum, option => {
              return _openBlock(), _createElementBlock("option", {
                key: option,
                value: option
              }, _toDisplayString(option), 9, _hoisted_151);
            }), 128))], 8, _hoisted_150)), [[_vModelSelect, materialFormData[field.key]]]) : field.type === 'boolean' ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 1,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            }, [...(_cache[85] || (_cache[85] = [_createElementVNode("option", {
              value: true
            }, "是", -1), _createElementVNode("option", {
              value: false
            }, "否", -1)]))], 8, _hoisted_152)), [[_vModelSelect, materialFormData[field.key]]]) : field.type === 'number' || field.type === 'integer' ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 2,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              type: "number",
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
              placeholder: field.placeholder || '请输入'
            }, null, 8, _hoisted_153)), [[_vModelText, materialFormData[field.key]]]) : field.type === 'email' ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 3,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              type: "email",
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
              placeholder: field.placeholder || '请输入邮箱'
            }, null, 8, _hoisted_154)), [[_vModelText, materialFormData[field.key]]]) : field.type === 'phone' ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 4,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              type: "tel",
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
              placeholder: field.placeholder || '请输入手机号'
            }, null, 8, _hoisted_155)), [[_vModelText, materialFormData[field.key]]]) : field.type === 'textarea' ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
              key: 5,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              rows: "3",
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
              placeholder: field.placeholder || '请输入'
            }, null, 8, _hoisted_156)), [[_vModelText, materialFormData[field.key]]]) : field.type === 'date' && field.format === 'date' ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 6,
              modelValue: materialFormData[field.key],
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              type: "date",
              class: "w-full",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择日期"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : field.type === 'date' && field.format === 'datetime' ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 7,
              modelValue: materialFormData[field.key],
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              type: "datetime",
              class: "w-full",
              format: "YYYY年MM月DD日 HH:mm",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              placeholder: "请选择日期时间"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : field.type === 'date' && field.format === 'time' ? (_openBlock(), _createBlock(_component_el_time_picker, {
              key: 8,
              modelValue: materialFormData[field.key],
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              class: "w-full",
              format: "HH:mm",
              "value-format": "HH:mm:ss",
              placeholder: "请选择时间"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 9,
              "onUpdate:modelValue": $event => materialFormData[field.key] = $event,
              type: "text",
              class: "w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
              placeholder: field.placeholder || '请输入'
            }, null, 8, _hoisted_157)), [[_vModelText, materialFormData[field.key]]])]);
          }), 128))])])) : _createCommentVNode("", true), materialFileFields.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_158, [_cache[90] || (_cache[90] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-3"
          }, "附件信息", -1)), _createElementVNode("div", _hoisted_159, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialFileFields.value, fileField => {
            return _openBlock(), _createElementBlock("div", {
              key: fileField.fieldCode,
              class: "border border-slate-200 rounded-lg p-4"
            }, [_createElementVNode("div", _hoisted_160, [_createElementVNode("div", _hoisted_161, _toDisplayString(fileField.label || fileField.fieldCode), 1), fileField.required ? (_openBlock(), _createElementBlock("span", _hoisted_162, "必传")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_163, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMaterialFilesByField(fileField.fieldCode), file => {
              return _openBlock(), _createElementBlock("div", {
                key: file.id,
                class: "material-file-row"
              }, [_createElementVNode("div", _hoisted_164, [_createElementVNode("div", {
                class: "material-file-name",
                title: file.originalName
              }, _toDisplayString(file.originalName || '附件'), 9, _hoisted_165), _createElementVNode("div", _hoisted_166, [_createElementVNode("span", null, "v" + _toDisplayString(file.version || '-'), 1), _createElementVNode("span", null, _toDisplayString(formatFileSize(file.fileSize) || '-'), 1), _createElementVNode("span", null, _toDisplayString(formatDateTime(file.uploadTime)), 1)])]), _createElementVNode("div", _hoisted_167, [_withDirectives(_createVNode(FileAttachment, {
                variant: "button",
                files: toMaterialPreviewFile(file),
                loader: loadMaterialPreviewFile
              }, null, 8, ["files"]), [[_directive_permission, 'customer:material:preview']]), _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "px-2 py-1 text-xs text-slate-600 hover:bg-slate-100 rounded",
                onClick: _withModifiers($event => handleDownloadMaterialFile(file), ["stop"])
              }, [...(_cache[87] || (_cache[87] = [_createTextVNode(" 下载 ", -1)]))], 8, _hoisted_168)), [[_directive_permission, 'customer:material:download']]), _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "px-2 py-1 text-xs text-red-600 hover:bg-red-50 rounded",
                onClick: _withModifiers($event => handleDeleteMaterialFile(file), ["stop"])
              }, [...(_cache[88] || (_cache[88] = [_createTextVNode(" 删除 ", -1)]))], 8, _hoisted_169)), [[_directive_permission, 'customer:material:delete']])])]);
            }), 128)), !getMaterialFilesByField(fileField.fieldCode).length ? (_openBlock(), _createElementBlock("div", _hoisted_170, "暂无文件")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_171, [_createElementVNode("div", _hoisted_172, [(_openBlock(), _createElementBlock("input", {
              key: uploadFileStates[fileField.fieldCode]?.inputKey,
              ref_for: true,
              ref: setMaterialFileInputRef(fileField.fieldCode),
              type: "file",
              class: "sr-only",
              accept: _unref(PREVIEWABLE_ATTACHMENT_ACCEPT),
              onChange: $event => handleMaterialFileChange(fileField.fieldCode, $event)
            }, null, 40, _hoisted_173)), _createElementVNode("button", {
              type: "button",
              class: "material-file-picker-button",
              onClick: $event => triggerMaterialFileInput(fileField.fieldCode)
            }, [...(_cache[89] || (_cache[89] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 4v16m8-8H4"
            })], -1), _createTextVNode(" 选择文件 ", -1)]))], 8, _hoisted_174), _createElementVNode("span", {
              class: "material-file-picker-name",
              title: uploadFileStates[fileField.fieldCode]?.file?.name || ''
            }, _toDisplayString(uploadFileStates[fileField.fieldCode]?.file?.name || '未选择文件'), 9, _hoisted_175)]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => uploadFileStates[fileField.fieldCode].changeReason = $event,
              type: "text",
              class: "w-full px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
              placeholder: "变更说明(可选)"
            }, null, 8, _hoisted_176), [[_vModelText, uploadFileStates[fileField.fieldCode].changeReason]]), _createElementVNode("button", {
              onClick: $event => handleUploadMaterialFile(fileField.fieldCode),
              disabled: !materialDetail.value?.id,
              class: "btn-primary disabled:opacity-50"
            }, " 上传新版本 ", 8, _hoisted_177)]), !materialDetail.value?.id ? (_openBlock(), _createElementBlock("div", _hoisted_178, "请先保存资料后再上传文件")) : _createCommentVNode("", true)]);
          }), 128))])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_179, [_createElementVNode("div", _hoisted_180, [materialDetail.value?.id ? (_openBlock(), _createElementBlock("span", _hoisted_181, "资料ID: " + _toDisplayString(materialDetail.value.id), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_182, "尚未创建资料"))]), _createElementVNode("div", _hoisted_183, [materialDetail.value?.id ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleDeleteMaterial,
            class: "px-4 py-2 border border-red-200 text-red-600 rounded-lg hover:bg-red-50"
          }, " 删除资料 ")) : _createCommentVNode("", true), _createElementVNode("button", {
            onClick: closeMaterialModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: handleSaveMaterial,
            disabled: isMaterialSaving.value,
            class: "btn-primary disabled:opacity-50"
          }, _toDisplayString(materialDetail.value?.id ? '保存更新' : '创建资料'), 9, _hoisted_184)])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDeleteMaterialModal.value,
          size: "sm",
          "z-index": 60,
          onClose: closeDeleteMaterialModal
        }, {
          default: _withCtx(() => [_cache[91] || (_cache[91] = _createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "删除资料")], -1)), _createElementVNode("div", _hoisted_185, " 确认删除资料 \"" + _toDisplayString(materialToDelete.value?.name) + "\" 吗？ ", 1), _createElementVNode("div", {
            class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteMaterialModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteMaterial,
            class: "btn-danger-secondary"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDeleteMaterialFileModal.value,
          size: "sm",
          "z-index": 60,
          onClose: closeDeleteMaterialFileModal
        }, {
          default: _withCtx(() => [_cache[92] || (_cache[92] = _createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "删除文件")], -1)), _createElementVNode("div", _hoisted_186, " 确认删除文件 \"" + _toDisplayString(materialFileToDelete.value?.originalName) + "\" 吗？ ", 1), _createElementVNode("div", {
            class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteMaterialFileModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteMaterialFile,
            class: "btn-danger-secondary"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showFollowupModal.value,
          size: "lg",
          "z-index": 60,
          onClose: _cache[10] || (_cache[10] = $event => showFollowupModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_187, [_createElementVNode("h3", _hoisted_188, _toDisplayString(followupForm.id ? '编辑跟进记录' : '添加跟进记录'), 1), _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = $event => showFollowupModal.value = false),
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[93] || (_cache[93] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_189, [_createElementVNode("div", null, [_cache[94] || (_cache[94] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("跟进方式 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_190, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(followupTypes, type => {
            return _createElementVNode("button", {
              key: type.value,
              onClick: $event => followupForm.type = type.value,
              class: _normalizeClass(['px-3 py-2 rounded-lg text-sm font-medium transition-colors border', followupForm.type === type.value ? 'bg-primary-50 border-primary-300 text-primary-700' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'])
            }, _toDisplayString(type.label), 11, _hoisted_191);
          }), 64))])]), _createElementVNode("div", null, [_cache[95] || (_cache[95] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("跟进内容 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => followupForm.content = $event),
            rows: "4",
            class: "form-textarea",
            placeholder: "请输入跟进内容"
          }, null, 512), [[_vModelText, followupForm.content]])]), _createElementVNode("div", _hoisted_192, [_createElementVNode("div", null, [_cache[96] || (_cache[96] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "本次跟进时长(分钟)", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => followupForm.duration = $event),
            type: "number",
            class: "form-input form-number w-full",
            placeholder: "如: 30"
          }, null, 512), [[_vModelText, followupForm.duration]])]), _createElementVNode("div", null, [_cache[97] || (_cache[97] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "下次跟进时间", -1)), _createVNode(_component_el_date_picker, {
            modelValue: followupForm.nextDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => followupForm.nextDate = $event),
            type: "date",
            class: "w-full",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择下次跟进时间"
          }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_193, [_createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = $event => showFollowupModal.value = false),
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: handleSubmitFollowup,
            class: "btn-primary disabled:opacity-60",
            disabled: isFollowupSubmitting.value
          }, _toDisplayString(isFollowupSubmitting.value ? '提交中...' : '保存'), 9, _hoisted_194)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDeleteFollowupModal.value,
          size: "sm",
          "z-index": 60,
          onClose: _cache[12] || (_cache[12] = $event => showDeleteFollowupModal.value = false)
        }, {
          default: _withCtx(() => [_cache[98] || (_cache[98] = _createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "确认删除")], -1)), _cache[99] || (_cache[99] = _createElementVNode("div", {
            class: "p-6 text-sm text-slate-600"
          }, " 确认删除该条跟进记录吗？此操作不可撤销。 ", -1)), _createElementVNode("div", _hoisted_195, [_createElementVNode("button", {
            onClick: _cache[11] || (_cache[11] = $event => showDeleteFollowupModal.value = false),
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteFollowup,
            class: "btn-danger-secondary"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(PlanDetailModal, {
          visible: showPlanDetailModal.value,
          "onUpdate:visible": _cache[13] || (_cache[13] = $event => showPlanDetailModal.value = $event),
          planData: planDetail.value
        }, null, 8, ["visible", "planData"]), _createVNode(OrderDetailModal, {
          visible: showOrderDetailModal.value,
          "onUpdate:visible": _cache[14] || (_cache[14] = $event => showOrderDetailModal.value = $event),
          orderDetail: orderDetail.value,
          traceList: orderTraceList.value,
          onReceive: openCustomerOrderReceiveModal,
          onEditTask: openCustomerOrderTaskEditModal,
          onEdit: handleCustomerOrderDetailEdit,
          onApprovalDetail: openOrderApprovalDetailModal,
          onRefreshDetail: handleCustomerOrderDetailRefresh,
          onExecutorChanged: handleCustomerOrderExecutorChanged
        }, null, 8, ["visible", "orderDetail", "traceList"]), _createVNode(OrderFormModal, {
          visible: showOrderEditModal.value,
          "onUpdate:visible": _cache[15] || (_cache[15] = $event => showOrderEditModal.value = $event),
          isEdit: true,
          editData: editOrderData.value,
          onSuccess: handleCustomerOrderSuccess
        }, null, 8, ["visible", "editData"]), _createVNode(AppModal, {
          visible: showTaskEditModal.value,
          size: "2xl",
          "z-index": 60,
          onClose: closeCustomerOrderTaskEditModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[101] || (_cache[101] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "编辑任务", -1)), _createElementVNode("button", {
            onClick: closeCustomerOrderTaskEditModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[100] || (_cache[100] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_196, [_createElementVNode("div", _hoisted_197, [_createElementVNode("div", _hoisted_198, [_cache[102] || (_cache[102] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "任务名称", -1)), _createElementVNode("span", _hoisted_199, _toDisplayString(selectedTask.value?.name), 1)]), selectedTask.value?.type ? (_openBlock(), _createElementBlock("div", _hoisted_200, [_cache[103] || (_cache[103] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "任务类型", -1)), _createElementVNode("span", _hoisted_201, _toDisplayString(selectedTask.value?.type), 1)])) : _createCommentVNode("", true), selectedTask.value?.assigneeName ? (_openBlock(), _createElementBlock("div", _hoisted_202, [_cache[104] || (_cache[104] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "负责人", -1)), _createElementVNode("div", _hoisted_203, [_createElementVNode("div", _hoisted_204, _toDisplayString(selectedTask.value?.assigneeName?.charAt(0)), 1), _createElementVNode("span", _hoisted_205, _toDisplayString(selectedTask.value?.assigneeName), 1)])])) : _createCommentVNode("", true), selectedTask.value?.startTime ? (_openBlock(), _createElementBlock("div", _hoisted_206, [_cache[105] || (_cache[105] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "开始时间", -1)), _createElementVNode("span", _hoisted_207, _toDisplayString(_ctx.$formatDateTime(selectedTask.value?.startTime)), 1)])) : _createCommentVNode("", true), selectedTask.value?.endTime ? (_openBlock(), _createElementBlock("div", _hoisted_208, [_cache[106] || (_cache[106] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "结束时间", -1)), _createElementVNode("span", _hoisted_209, _toDisplayString(_ctx.$formatDateTime(selectedTask.value?.endTime)), 1)])) : _createCommentVNode("", true)]), _createVNode(_component_el_form, {
            ref_key: "taskFormRef",
            ref: taskFormRef,
            model: taskFormData,
            rules: taskRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "任务状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: taskFormData.status,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => taskFormData.status = $event),
                placeholder: "请选择任务状态",
                class: "w-full",
                onChange: handleTaskStatusChange
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "待开始",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "进行中",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "已完成",
                  value: 2
                }), _createVNode(_component_el_option, {
                  label: "已暂停",
                  value: 3
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "任务进度",
              prop: "progress"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_210, [_createVNode(_component_el_slider, {
                modelValue: taskFormData.progress,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => taskFormData.progress = $event),
                min: 0,
                max: 100,
                class: "flex-1"
              }, null, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
                modelValue: taskFormData.progress,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => taskFormData.progress = $event),
                min: 0,
                max: 100,
                class: "w-25"
              }, null, 8, ["modelValue"]), _cache[107] || (_cache[107] = _createElementVNode("span", {
                class: "text-slate-600"
              }, "%", -1))])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: taskFormData.remark,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => taskFormData.remark = $event),
                type: "textarea",
                rows: 4,
                placeholder: "请输入备注信息"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_211, [_createElementVNode("button", {
            onClick: closeCustomerOrderTaskEditModal,
            class: "px-5 py-2.5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
          }, "取消"), _createElementVNode("button", {
            disabled: taskSubmitting.value,
            onClick: handleCustomerOrderTaskSubmit,
            class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50"
          }, _toDisplayString(taskSubmitting.value ? '保存中...' : '保存'), 9, _hoisted_212)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showBillingReceiveModal.value,
          size: "md",
          "z-index": 60,
          onClose: closeCustomerOrderReceiveModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[109] || (_cache[109] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "账单收款", -1)), _createElementVNode("button", {
            onClick: closeCustomerOrderReceiveModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[108] || (_cache[108] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_213, [_createVNode(_component_el_form, {
            ref_key: "receiveFormRef",
            ref: receiveFormRef,
            model: receiveFormData,
            rules: receiveRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "应收金额"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_214, "¥" + _toDisplayString(selectedBilling.value?.amount?.toLocaleString()), 1)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "已收金额"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_215, "¥" + _toDisplayString(selectedBilling.value?.paidAmount?.toLocaleString() || '0'), 1)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "待收金额"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_216, "¥" + _toDisplayString(receiveRemainingAmount.value.toLocaleString()), 1)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "收款金额",
              prop: "paidAmount"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: receiveFormData.paidAmount,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => receiveFormData.paidAmount = $event),
                min: 0.01,
                max: receiveRemainingAmount.value,
                precision: 2,
                step: 100,
                class: "w-50"
              }, null, 8, ["modelValue", "max"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "支付渠道",
              prop: "payChannel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: receiveFormData.payChannel,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => receiveFormData.payChannel = $event),
                placeholder: "请选择支付渠道",
                class: "w-50"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(payChannelOptions, channel => {
                  return _createVNode(_component_el_option, {
                    key: channel.value,
                    label: channel.label,
                    value: channel.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_217, [_createElementVNode("button", {
            onClick: closeCustomerOrderReceiveModal,
            class: "px-5 py-2.5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
          }, "取消"), _createElementVNode("button", {
            disabled: receiveSubmitting.value,
            onClick: handleCustomerOrderReceiveSubmit,
            class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50"
          }, "确认收款", 8, _hoisted_218)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(ProposalFormModal, {
          visible: showProposalFormModal.value,
          "onUpdate:visible": _cache[22] || (_cache[22] = $event => showProposalFormModal.value = $event),
          isEdit: isProposalEdit.value,
          editData: proposalFormEditData.value,
          onSuccess: handleProposalSuccess
        }, null, 8, ["visible", "isEdit", "editData"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: selectedApprovalType.value,
          title: "审批详情"
        }, null, 8, ["modelValue", "instance-id", "type"])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};